import { devicesNe } from '@mangovoice/devices-ui'
import { extensionsNe } from '@mangovoice/extensions-ui'
import { hotelsNe } from '@mangovoice/hotels-ui'
import { messagingNe } from '@mangovoice/messaging-ui'
import { musicOnHoldNe } from '@mangovoice/music-on-hold-ui'
import { pbxLocationsNe } from '@mangovoice/pbx-locations-ui'
import { pbxSettingsNe } from '@mangovoice/pbx-settings-ui'
import { phoneNumbersNe } from '@mangovoice/phone-numbers-ui'
import { soundClipsNe } from '@mangovoice/soundclips-ui'
import { systemSettingsNe } from '@mangovoice/system-settings-ui'
import { userGroupsNe } from '@mangovoice/user-groups-ui'
import { webhooksNe } from '@mangovoice/webhooks-ui'

import { en } from './en'
import { scheduleNe } from './schedule.ne'

export const ne = {
  translation: {
    'Welcome to React': `React र react-i18next मा स्वागत छ`,
    yesterday: `हिजो`,
    today: `आज`,
    day: `दिन`,
    hour: `घण्टा`,
    week: `सप्ताह`,

    baseSettings: {
      profile: `प्रोफाइल`,
      snippets: `स्निपेटहरू`,
      phone: `फोन`,
      fax: `फ्याक्स`,
      notifications: `सूचनाहरू`,
      audio: `अडियो`,
      updates: `संस्करण`,
      blockedNumbers: `ब्लक गरिएको नम्बरहरू`,
      integrations: `एकीकरण`,
      callCenter: `कल सेन्टर`,
      experiments: `प्रयोगहरू`,
      shortcutKeys: `सर्टकट कुञ्जीहरू`,
      collapse: `सङ्कुचित गर`,
      expand: `फैलाउनुहोस्`,
      new: `नयाँ`,
      admin: `प्रशासन`,
      closeAdmin: `प्रशासन बन्द गर्नुहोस्`,
      adminSections: `प्रशासन खण्डहरू`,
    },

    nav: {
      voicemail: `भ्वाइसमेल`,
      calls: `कलहरू`,
      missedCalls: `छुटेका कलहरू`,
      text: `पाठ`,
      messaging: `सन्देश`,
      fax: `फ्याक्स`,
      contacts: `सम्पर्कहरू`,
      settings: `सेटिङहरू`,
      webPhone: `वेब फोन`,
      reporting: `रिपोर्टिङ`,
      hotels: `होटल`,
      switchboard: `स्विचबोर्ड`,
      devices: `उपकरणहरू`,
      extensions: `एक्सटेन्सनहरू`,
      messagingGroups: `सन्देश समूहहरू`,
      soundClips: `साउन्ड क्लिपहरू`,
      musicOnHold: `होल्ड संगीत`,
      phoneNumbers: `फोन नम्बरहरू`,
      locations: `स्थानहरू`,
      pbxSettings: `पीबीएक्स सेटिङहरू`,
      schedules: `तालिकाहरू`,
      integrations: `एकीकरणहरू`,
      systemSettings: `प्रणाली सेटिङहरू`,
      users: `प्रयोगकर्ताहरू`,
      userGroups: `प्रयोगकर्ता समूहहरू`,
      apiAccess: `API पहुँच`,
      developers: `विकासकर्ताहरू`,
      mainNavigation: `मुख्य नेभिगेसन`,
      skipToMainContent: `मुख्य सामग्रीमा जानुहोस्`,
      callAnalytics: `कल विश्लेषण`,
      status: `स्थिति`,
    },

    users: {
      detail: {
        close: `प्रयोगकर्ता विवरण बन्द गर्नुहोस्`,
        loadingUser: `प्रयोगकर्ता लोड हुँदै...`,
        pbxAssociations: {
          heading: `पीबीएक्स सम्बन्धहरू`,
          addToPbx: `पीबीएक्समा थप्नुहोस्`,
          filterPlaceholder: `पीबीएक्स सम्बन्धहरू फिल्टर गर्नुहोस्...`,
          filterAriaLabel: `पीबीएक्स सम्बन्धहरू फिल्टर गर्नुहोस्`,
          empty: `यो प्रयोगकर्ता कुनै पीबीएक्समा असाइन गरिएको छैन।`,
          noMatches: `तपाईंको खोजसँग मेल खाने कुनै पीबीएक्स सम्बन्ध छैन।`,
        },
      },
      generalInfo: {
        heading: `प्रयोगकर्ता जानकारी`,
        copyCognitoKey: `"Cognito Key" प्रतिलिपि गर्नुहोस्`,
        resetPassword: `पासवर्ड रिसेट गर्नुहोस्`,
        resetPasswordAria: `पासवर्ड रिसेट गर्नुहोस्`,
        editUserInformation: `प्रयोगकर्ता जानकारी सम्पादन गर्नुहोस्`,
        deactivateUser: `प्रयोगकर्ता निष्क्रिय गर्नुहोस्`,
        activateUser: `प्रयोगकर्ता सक्रिय गर्नुहोस्`,
        username: `प्रयोगकर्ता नाम`,
        name: `नाम`,
        role: `भूमिका`,
        email: `इमेल`,
        lastLoggedIn: `अन्तिम लगइन`,
        created: `सिर्जना गरियो`,
        updated: `अद्यावधिक गरियो`,
      },
      pbxAssociationCard: {
        editAria: `{{pbxName}} को सम्बन्ध सम्पादन गर्नुहोस्`,
        removeAria: `{{pbxName}} बाट {{userName}} हटाउनुहोस्`,
        assignedExtensions: `असाइन गरिएका एक्स्टेन्सनहरू`,
        faxEmail: `फ्याक्स इमेल`,
        faxNumber: `फ्याक्स नम्बर`,
        pin: `PIN`,
        faxTitle: `फ्याक्स शीर्षक`,
      },
      phonePermissions: {
        heading: `फोन अनुमतिहरू`,
        loading: `फोन अनुमतिहरू लोड हुँदै...`,
        empty: `यो प्रयोगकर्ता कुनै फोन अनुमति समूहमा असाइन गरिएको छैन।`,
        editAria: `{{pbxName}} को फोन अनुमतिहरू सम्पादन गर्नुहोस्`,
        noGroupsAssigned: `कुनै समूह असाइन गरिएको छैन।`,
      },
      pbxUserForm: {
        titleAdd: `पीबीएक्समा थप्नुहोस्`,
        titleEdit: `पीबीएक्स सम्बन्ध सम्पादन गर्नुहोस्`,
        pbxLabel: `पीबीएक्स`,
        pbxSearchPlaceholder: `नामद्वारा पीबीएक्स खोज्नुहोस्...`,
        pbxSearchAria: `नामद्वारा पीबीएक्स विकल्पहरू खोज्नुहोस्`,
        pbxSearching: `खोज्दै...`,
        pbxTypeToSearch: `पीबीएक्स खोज्न टाइप गर्नुहोस्...`,
        pbxNoMatches: `त्यो खोजसँग मेल खाने कुनै पीबीएक्स छैन।`,
        faxTitleLabel: `फ्याक्स शीर्षक`,
        faxTitlePlaceholder: `फ्याक्स शीर्षक`,
        sendingFaxEmailLabel: `पठाउने फ्याक्स इमेल`,
        sendingFaxEmailPlaceholder: `फ्याक्स इमेल ठेगाना`,
        invalidEmail: `वैध इमेल ठेगाना प्रविष्ट गर्नुहोस्।`,
        sendingFaxNumberLabel: `पठाउने फ्याक्स नम्बर`,
        faxNumberSearchPlaceholder: `फ्याक्स नम्बरहरू खोज्नुहोस्...`,
        faxNumberSelectPbxFirst: `पहिले पीबीएक्स चयन गर्नुहोस्`,
        faxNumberSearchAria: `पठाउने फ्याक्स नम्बर विकल्पहरू खोज्नुहोस्`,
        faxNumbersLoading: `फ्याक्स नम्बरहरू लोड हुँदै...`,
        faxNumbersEmpty: `यस पीबीएक्सको लागि कुनै फ्याक्स नम्बर फेला परेन।`,
        pinLabel: `PIN`,
        pinPlaceholder: `4-अङ्कको PIN (1000-9999)`,
        userGroupsLabel: `प्रयोगकर्ता समूहहरू`,
        userGroupsSelected_one: `{{count}} चयन गरियो`,
        userGroupsSelected_other: `{{count}} चयन गरिए`,
        cancel: `रद्द गर्नुहोस्`,
        submitAdd: `पीबीएक्समा थप्नुहोस्`,
        submitEdit: `परिवर्तनहरू सुरक्षित गर्नुहोस्`,
      },
      editPhonePermissions: {
        title: `फोन अनुमतिहरू सम्पादन: {{userName}}`,
        pbxLabel: `पीबीएक्स: {{pbxName}}`,
        groups: `समूहहरू`,
        noGroups: `यस पीबीएक्सको लागि कुनै समूह उपलब्ध छैन।`,
        required: `(आवश्यक)`,
        selectedCount: `{{total}} मध्ये {{selected}} चयन गरियो`,
        close: `बन्द गर्नुहोस्`,
        submit: `फोन अनुमतिहरू अद्यावधिक गर्नुहोस्`,
      },
      formatAssignedAssets: {
        extension_one: `{{count}} असाइन गरिएको एक्स्टेन्सन`,
        extension_other: `{{count}} असाइन गरिएका एक्स्टेन्सनहरू`,
        device_one: `{{count}} असाइन गरिएको उपकरण`,
        device_other: `{{count}} असाइन गरिएका उपकरणहरू`,
        and: ` र `,
      },
      toast: {
        userCreated: {
          title: `प्रयोगकर्ता सिर्जना गरियो`,
          description: `{{firstName}} {{lastName}} सिर्जना गरिएको छ।`,
        },
        userCreateError: {
          title: `प्रयोगकर्ता सिर्जना त्रुटि`,
        },
        userUpdated: {
          title: `प्रयोगकर्ता अद्यावधिक गरियो`,
        },
        userUpdateError: {
          title: `प्रयोगकर्ता अद्यावधिक त्रुटि`,
        },
        pbxAdded: {
          title: `पीबीएक्समा प्रयोगकर्ता थपियो`,
        },
        pbxUpdated: {
          title: `पीबीएक्स सम्बन्ध अद्यावधिक गरियो`,
        },
        error: `त्रुटि`,
        associationRemoved: {
          title: `सम्बन्ध हटाइयो`,
          description: `{{name}} यस पीबीएक्सबाट हटाइएको छ।`,
        },
        alreadyRemoved: {
          title: `पहिले नै हटाइएको`,
          description: `यो प्रयोगकर्ता पीबीएक्समा फेला परेन र सम्भवतः पहिले नै हटाइएको हुन सक्छ।`,
        },
        removeFailed: `पीबीएक्सबाट प्रयोगकर्ता हटाउन असफल।`,
        noPhonePermissionChanges: {
          title: `कुनै फोन अनुमति परिवर्तन छैन`,
        },
        phonePermissionsUpdated: {
          title: `फोन अनुमतिहरू अद्यावधिक गरियो`,
        },
        updateGroupFailed: `"{{name}}" अद्यावधिक गर्न असफल।`,
        phonePermissionsUpdateError: {
          title: `फोन अनुमतिहरू अद्यावधिक गर्न असफल`,
          fallback: `फोन अनुमतिहरू अद्यावधिक गर्न असमर्थ।`,
        },
        defaultUserName: `प्रयोगकर्ता`,
      },
      removeDialog: {
        cannotTitle: `पीबीएक्सबाट प्रयोगकर्ता हटाउन सकिँदैन`,
        thisUserCapitalized: `यो प्रयोगकर्ता`,
        cannotBody: `<bold>{{userName}}</bold>सँग यस पीबीएक्समा {{assets}} छ। यस प्रयोगकर्तालाई पीबीएक्सबाट हटाउनु अघि यी सम्पत्तिहरू पुन: असाइन गर्नुहोस् वा मेटाउनुहोस्।`,
        ok: `ठीक`,
        confirmTitle: `पीबीएक्सबाट प्रयोगकर्ता हटाउने?`,
        thisUser: `यो प्रयोगकर्ता`,
        confirmBody: `यसले चयन गरिएको पीबीएक्सबाट <bold>{{userName}}</bold>लाई हटाउनेछ।`,
        cancel: `रद्द गर्नुहोस्`,
        remove: `हटाउनुहोस्`,
      },
      list: {
        title: `प्रयोगकर्ताहरू`,
        searchPlaceholder: `नाम, प्रयोगकर्ता नाम वा इमेलद्वारा खोज्नुहोस्...`,
        searchAriaLabel: `प्रयोगकर्ता खोज्नुहोस्`,
        newUser: `नयाँ प्रयोगकर्ता`,
        newUserAriaLabel: `नयाँ प्रयोगकर्ता सिर्जना गर्नुहोस्`,
        newUserDisabledAriaLabel: `नयाँ प्रयोगकर्ता सिर्जना गर्नुहोस् (असक्षम)`,
        newUserPermissionTooltip: `तपाईंलाई प्रयोगकर्ता सिर्जना गर्ने अनुमति छैन`,
        clickToCopy: `प्रतिलिपि गर्न क्लिक गर्नुहोस्`,
        copied: `प्रतिलिपि गरियो!`,
        loading: `प्रयोगकर्ताहरू लोड हुँदैछन्...`,
        error: `त्रुटि`,
        emptyNoResultsTitle: `कुनै परिणाम फेला परेन`,
        emptyNoResultsDescription: `आफ्नो खोज शब्दहरू मिलाउने प्रयास गर्नुहोस्`,
        emptyNoUsersTitle: `अझै कुनै प्रयोगकर्ता छैन`,
        emptyNoUsersDescription: `आफ्नो पहिलो प्रयोगकर्ता सिर्जना गरेर सुरु गर्नुहोस्`,
        removeFromPbxTitle: `पीबीएक्सबाट {{name}} हटाउनुहोस्`,
        removeFromPbxDescription: `यदि यस प्रयोगकर्तालाई कुनै पनि डिभाइस वा एक्सटेन्सनहरू तोकिएको छ भने, ती चयन गरिएको प्रयोगकर्तालाई पुनः तोकिनेछन्।`,
        reassignAndRemove: `पुनः तोक्नुहोस् र हटाउनुहोस्`,
        cancel: `रद्द गर्नुहोस्`,
        reassignAssetsTo: `सम्पत्तिहरू पुनः तोक्नुहोस्`,
        selectUserPlaceholder: `एक प्रयोगकर्ता चयन गर्नुहोस्...`,
        searchingUsers: `खोजी गर्दै...`,
        noMatchingUsers: `मिल्ने प्रयोगकर्ता छैन`,
        searchUsersToReassign: `सम्पत्ति पुन: असाइन गर्न प्रयोगकर्ता खोज्नुहोस्`,
        candidateLoadFailed: `प्रयोगकर्ता लोड गर्न सकिएन। जडान जाँच गरी पुन: प्रयास गर्नुहोस्।`,
        noOtherUsersOnPbx: `यस पीबीएक्समा अन्य कुनै प्रयोगकर्ताहरू छैनन्। यस प्रयोगकर्तालाई हटाउनु अघि अर्को प्रयोगकर्ता थप्नुहोस् ताकि तिनका सम्पत्तिहरू पुनः तोकिन सकून्।`,
        defaultUserName: `प्रयोगकर्ता`,
        column: {
          name: `नाम`,
          usernameOrEmail: `प्रयोगकर्ता नाम / इमेल`,
          role: `भूमिका`,
          faxEmail: `फ्याक्स इमेल`,
          lastLogin: `पछिल्लो लगइन`,
          lastUpdated: `पछिल्लो अद्यावधिक`,
          action: `कार्य`,
        },
        pagination: {
          resultsPerPage: `प्रति पृष्ठ परिणाम:`,
          previousPage: `अघिल्लो पृष्ठ`,
          nextPage: `अर्को पृष्ठ`,
          jumpToPage: `पृष्ठ {{page}} मा जानुहोस्`,
          all: `सबै`,
          recordRange: `{{start}}—{{end}} मध्ये {{total}}`,
          recordRangeEmpty: `0 मध्ये 0`,
        },
      },
      resetPassword: {
        toast: {
          copiedTitle: `पासवर्ड रिसेट लिंक क्लिपबोर्डमा कपी गरियो`,
          copyFailedTitle: `पासवर्ड रिसेट लिंक बनाइयो, तर कपी गर्न सकिएन`,
          manualCopyDescription: `यो रिसेट URL म्यानुअली कपी गर्नुहोस्: {{url}}`,
          missingUrlTitle: `पासवर्ड रिसेट लिंक बनाउन असफल`,
          missingUrlDescription: `कुनै रिसेट URL प्राप्त भएन।`,
          requestFailedTitle: `पासवर्ड रिसेट गर्न असफल`,
          unexpectedErrorDescription: `अप्रत्याशित त्रुटि भयो।`,
        },
      },
      create: {
        loadingForm: `प्रयोगकर्ता फारम लोड हुँदै...`,
      },
      edit: {
        loadingDetails: `प्रयोगकर्ता विवरण लोड हुँदै...`,
        retryLoadingRoles: `भूमिकाहरू पुनः लोड गर्नुहोस्`,
      },
      form: {
        heading: {
          newUser: `नयाँ प्रयोगकर्ता`,
          editUser: `प्रयोगकर्ता सम्पादन गर्नुहोस्`,
        },
        section: {
          pbxAssignment: `पीबीएक्स असाइनमेन्ट`,
        },
        field: {
          firstName: `पहिलो नाम`,
          lastName: `थर`,
          username: `प्रयोगकर्ता नाम`,
          usernameHelper: `आवश्यक। ४-१५० क्यारेक्टर। अक्षर, अंक, थोप्लो वा ड्यासहरू मात्र। ध्यान दिनुहोस्: प्रयोगकर्ता नाम सिर्जना पछि परिवर्तन गर्न सकिँदैन।`,
          email: `इमेल`,
          emailHelper: `वैकल्पिक। एक पटक सेट गरिएपछि इमेल परिवर्तन गर्न सकिँदैन।`,
          isStaff: `के Mango कर्मचारी हो?`,
          staffHelperIntro: `यस पदनामले केही अपवादहरूसहित प्रणालीमा पूर्ण पहुँच प्रदान गर्दछ:`,
          staffHelperBullet1: `प्रयोगकर्ताले अन्य प्रयोगकर्ताहरूलाई Mango सुपरयुजर पदनाम दिन सक्दैन।`,
          staffHelperBullet2: `प्रयोगकर्ताले Mango सुपरयुजरहरू परिमार्जन गर्न सक्दैन।`,
          staffHelperBullet3: `प्रयोगकर्ताले सर्भर, प्रदायक वा उपकरण निर्माताहरू परिमार्जन गर्न सक्दैन।`,
          isSuperuser: `Mango सुपरयुजर`,
          role: `भूमिका`,
          rolePlaceholder: `------`,
          roleUnavailable: `भूमिका विकल्पहरू उपलब्ध छैन`,
          roleUnavailableHelper: `भूमिका विकल्पहरू उपलब्ध छैनन्।`,
          roleWarning: `चेतावनी: यो भूमिका प्रयोगकर्ता सम्बन्धित सबै पीबीएक्समा लागू हुन्छ। परिवर्तन गर्नु अघि प्रभावहरूलाई सावधानीपूर्वक विचार गर्नुहोस्।`,
          pbx: `पीबीएक्स`,
          pbxSearchPlaceholder: `नामद्वारा पीबीएक्स खोज्नुहोस्...`,
          pbxSearchAriaLabel: `नामद्वारा पीबीएक्स विकल्पहरू खोज्नुहोस्`,
          pin: `PIN`,
          pinPlaceholder: `४ अंकको PIN (1000-9999)`,
          faxTitle: `फ्याक्स शीर्षक`,
          faxTitlePlaceholder: `फ्याक्स शीर्षक`,
          sendingFaxEmail: `फ्याक्स पठाउने इमेल`,
          sendingFaxEmailPlaceholder: `फ्याक्स इमेल ठेगाना`,
          sendingFaxNumber: `फ्याक्स पठाउने नम्बर`,
          searchFaxNumbers: `फ्याक्स नम्बरहरू खोज्नुहोस्...`,
          selectPbxFirst: `पहिले एउटा पीबीएक्स चयन गर्नुहोस्`,
          searchFaxNumbersAriaLabel: `फ्याक्स पठाउने नम्बर विकल्पहरू खोज्नुहोस्`,
          userGroups: `प्रयोगकर्ता समूहहरू`,
        },
        combobox: {
          searching: `खोज्दै...`,
          typeToSearchPbx: `पीबीएक्स खोज्न टाइप गर्नुहोस्...`,
          noPbxMatches: `उक्त खोजसँग मेल खाने पीबीएक्स छैन।`,
          loadingFaxNumbers: `फ्याक्स नम्बरहरू लोड हुँदै...`,
          noFaxNumbers: `यस पीबीएक्सका लागि कुनै फ्याक्स नम्बर फेला परेन।`,
        },
        userGroups: {
          placeholder: `प्रयोगकर्ता समूहहरू चयन गर्नुहोस्...`,
          searchPlaceholder: `प्रयोगकर्ता समूहहरू फिल्टर गर्नुहोस्...`,
          emptyLabel: `यस पीबीएक्सका लागि कुनै प्रयोगकर्ता समूह उपलब्ध छैन।`,
          noResultsLabel: `तपाईंको फिल्टरसँग मेल खाने कुनै प्रयोगकर्ता समूह छैन।`,
          summary_one: `{{count}} समूह चयन गरियो`,
          summary_other: `{{count}} समूहहरू चयन गरिए`,
        },
        button: {
          cancel: `रद्द गर्नुहोस्`,
          saveAndCreateAnother: `सुरक्षित गरेर अर्को सिर्जना गर्नुहोस्`,
          createUser: `प्रयोगकर्ता सिर्जना गर्नुहोस्`,
          saveChanges: `परिवर्तनहरू सुरक्षित गर्नुहोस्`,
        },
      },
    },

    switchboard: {
      list: {
        title: `स्विचबोर्ड`,
        subtitle: `तपाईंको भ्वाइस प्रणालीको लागि कल फ्लो सिर्जना र व्यवस्थापन गर्नुहोस्`,
        newSwitchboard: `नयाँ स्विचबोर्ड`,
        search: {
          placeholder: `नामले खोज्नुहोस्...`,
        },
        pagination: {
          resultsPerPage: `पृष्ठमा नतिजा:`,
          previousPage: `अघिल्लो पृष्ठ`,
          nextPage: `अर्को पृष्ठ`,
          jumpToPage: `पृष्ठ {{page}} मा जानुहोस्`,
          all: `सबै`,
        },
        grid: {
          errorTitle: `त्रुटि`,
          errorLoading: `स्विचबोर्डहरू लोड गर्दा त्रुटि:`,
          checkConsole: `विवरणहरूको लागि कन्सोल जाँच्नुहोस्`,
          loading: `स्विचबोर्डहरू लोड हुँदैछ...`,
        },
        empty: {
          noDataTitle: `अहिले सम्म कुनै स्विचबोर्ड छैन`,
          noDataDescription: `तपाईंको पहिलो स्विचबोर्ड सिर्जना गरेर सुरु गर्नुहोस्`,
          noResultsTitle: `यो पृष्ठमा कुनै स्विचबोर्ड छैन`,
          noResultsDescription: `तपाईंको पृष्ठ साइज समायोजन गर्नुहोस् वा अर्को पृष्ठमा जानुहोस्`,
          noSearchResultsTitle: `कुनै नतिजा फेला परेन`,
          noSearchResultsDescription: `तपाईंको खोज शब्दहरू समायोजन गर्न प्रयास गर्नुहोस्`,
        },
        card: {
          editAria: `स्विचबोर्ड सम्पादन गर्नुहोस्`,
          deleteAria: `मेट्नुहोस्`,
          lastUpdated: `अन्तिम अपडेट`,
        },
        delete: {
          title: `स्विचबोर्ड मेट्नुहोस्`,
          body: `के तपाईं निश्चित हुनुहुन्छ "{{displayName}}" मेट्न चाहनुहुन्छ? यो कार्य पूर्ववत गर्न सकिँदैन।`,
          cancel: `रद्द गर्नुहोस्`,
          confirm: `मेट्नुहोस्`,
        },
        deleteSuccessToast: `स्विचबोर्ड मेटियो`,
        deleteFailedToast: `स्विचबोर्ड मेट्न असफल`,
        edit: {
          title: `स्विचबोर्ड सम्पादन गर्नुहोस्`,
          nameLabel: `नाम`,
          namePlaceholder: `उदा., स्विचबोर्ड - 7074`,
          numberLabel: `नम्बर`,
          numberPlaceholder: `उदा., 7074`,
          omitFromDirectoryLabel: `निर्देशिकाबाट बाहिर निकाल्नुहोस्`,
          omitNo: `होइन`,
          omitYes: `हो`,
          cancel: `रद्द गर्नुहोस्`,
          submit: `स्विचबोर्ड अपडेट गर्नुहोस्`,
        },
      },
      edit: {
        loading: `स्विचबोर्ड लोड हुँदैछ...`,
        notFound: {
          title: `स्विचबोर्ड फेला परेन`,
          errorLoading: `स्विचबोर्ड लोड गर्दा त्रुटि: {{message}}`,
          description: `एक्सटेन्सन {{extensionDialPlan}} को स्विचबोर्ड API मा अस्तित्वमा छैन।`,
          thisCouldMean: `यसको मतलब यो हुन सक्छ:`,
          reasonDeleted: `स्विचबोर्ड मेटिएको थियो`,
          reasonNoData: `एक्सटेन्सन अस्तित्वमा छ तर स्विचबोर्ड डाटा छैन`,
          reasonCorrupted: `डाटा पुनर्स्थापना भन्दा बढी क्षतिग्रस्त छ`,
          backToList: `← स्विचबोर्ड सूचीमा फर्कनुहोस्`,
          unknownError: `अज्ञात त्रुटि`,
        },
        save: {
          cannotSave: `स्विचबोर्ड सेभ गर्न सकिँदैन`,
          success: `स्विचबोर्ड सेभ भयो`,
          failed: `स्विचबोर्ड सेभ गर्न असफल`,
          requiredFieldError: `{{node}}: {{message}}`,
          unexpectedError: `अप्रत्याशित त्रुटि भयो।`,
          targetMismatch: `लोड गरिएको स्विचबोर्ड यस पृष्ठसँग मेल खाँदैन। सेभ गर्नु अघि रिफ्रेस गर्नुहोस्।`,
        },
        header: {
          backToList: `स्विचबोर्ड सूचीमा फर्कनुहोस्`,
          defaultName: `स्विचबोर्ड {{extensionDialPlan}}`,
          deleteSwitchboard: `स्विचबोर्ड मेटाउनुहोस्`,
          save: `सेभ गर्नुहोस्`,
          revertLocalChanges: `स्थानीय परिवर्तनहरू फिर्ता गर्नुहोस्`,
          refreshSwitchboard: `स्विचबोर्ड रिफ्रेस गर्नुहोस्`,
        },
        oldFormat: {
          warning: `⚠️ चेतावनी: स्विचबोर्ड डाटा पुरानो ढाँचामा छ`,
          description: `यो स्विचबोर्ड पुरानो सम्पादकले सिर्जना गरिएको थियो। नयाँ ढाँचामा माइग्रेट नगरेसम्म दृश्य प्रवाह देखाउन सकिँदैन।`,
        },
        routeConflict: {
          title: `राउटिङ विवाद`,
          description: `{{node}} → {{route}} मा धेरै गन्तव्यहरू छन्। सेभ गर्नुअघि एउटा हटाउनुहोस्।`,
        },
        unconfiguredSchedule: {
          description: `यो कल फ्लोको तालिका नोडमा कुनै तालिका छानिएको छैन। सेभ गर्नुअघि तालिका छान्नुहोस्, वा नोड विच्छेद गर्नुहोस्।`,
          descriptionPlural: `यो कल फ्लोका {{count}} तालिका नोडहरूमा कुनै तालिका छानिएको छैन। सेभ गर्नुअघि प्रत्येकमा तालिका छान्नुहोस्, वा तिनलाई विच्छेद गर्नुहोस्।`,
        },
        canvas: {
          emptyTitle: `अहिले सम्म कुनै फ्लो कन्फिगर गरिएको छैन`,
          emptyDescription: `तपाईंको कल फ्लो बनाउन "Add Node" मा क्लिक गर्नुहोस्`,
          validationToastTitle: `चेतावनी!`,
          invalidConnection: `अवैध जडान`,
        },
        unsavedChanges: {
          title: `नसेभ गरिएका परिवर्तनहरू`,
          body: `तपाईंसँग नसेभ गरिएका परिवर्तनहरू छन्। के तपाईं जान निश्चित हुनुहुन्छ?`,
          stay: `रहनुहोस्`,
          save: `सेभ गर्नुहोस्`,
          leave: `छोड्नुहोस्`,
        },
        revert: {
          title: `स्थानीय परिवर्तनहरू फिर्ता गर्ने?`,
          body: `यसले यो ब्राउजर सेसनमा गरिएका परिवर्तनहरू हटाउँछ र तपाईंको अन्तिम सेभ गरिएको स्विचबोर्ड फेरि लोड गर्छ। पहिले नै सेभ भएको कुरा मेटाइँदैन।`,
          cancel: `रद्द गर्नुहोस्`,
          confirm: `परिवर्तनहरू फिर्ता गर्नुहोस्`,
          success: `स्थानीय परिवर्तनहरू फिर्ता गरियो`,
          successDescription: `तपाईंको अन्तिम सेभ गरिएको स्विचबोर्ड पुनर्स्थापित गरियो।`,
        },
        versionConflict: {
          title: `नयाँ अपडेटहरू उपलब्ध छन्`,
          body: `अरू कसैले यो स्विचबोर्डमा परिवर्तनहरू सेभ गरेको छ। आफ्ना हालका परिवर्तनहरू राख्नुहोस्, वा सर्भरको नयाँ सेभ गरिएको संस्करण लोड गर्नुहोस्।`,
          keepWorking: `मेरो परिवर्तनहरू राख्नुहोस्`,
          loadLatest: `नयाँ परिवर्तनहरू लोड गर्नुहोस्`,
        },
        refresh: {
          newerVersionTitle: `स्विचबोर्ड रिफ्रेस भयो`,
          newerVersionDescription: `नयाँ सेभ गरिएको संस्करण भेटियो र लोड गरियो।`,
        },
        configPanel: {
          title: `{{type}} कन्फिगर गर्नुहोस्`,
          notImplemented: `यो नोड प्रकारको लागि कन्फिगरेसन UI अहिले सम्म लागू गरिएको छैन।`,
          cancel: `रद्द गर्नुहोस्`,
          save: `सेभ गर्नुहोस्`,
        },
      },
      nodeLabels: {
        start: `सुरु`,
        transfer: `ट्रान्सफर`,
        transfer_and_continue: `ट्रान्सफर र जारी राख्नुहोस्`,
        queue: `क्यू`,
        auto_attendant: `ऑटो अटेन्डेन्ट`,
        external_transfer: `बाह्य ट्रान्सफर`,
        leave_voicemail: `भ्वाइसमेल छोड्नुहोस्`,
        schedule: `तालिका`,
        day_night: `दिन/रात`,
        dial_by_name: `नामले डायल गर्नुहोस्`,
        sound_clip: `साउन्ड क्लिप`,
        wait: `पर्खनुहोस्`,
        hang_up: `ह्याङ अप`,
        jump_to_switchboard: `स्विचबोर्डमा जानुहोस्`,
        conference_room: `कन्फरेन्स रुम`,
        transfer_and_rollover: `ट्रान्सफर र रोलओभर`,
        call_distribution: `कल वितरण`,
        change_caller_id: `कलर आइडी परिवर्तन गर्नुहोस्`,
        webhook: `वेबहुक`,
        interactive_webhook: `इन्टरएक्टिभ वेबहुक`,
        fax_detect: `फ्याक्स पत्ता लगाउनुहोस्`,
        sms_notification: `एसएमएस सूचना`,
        ai_agent_v1: `AI एजेन्ट`,
      },
      dialogs: {
        deleteNode: {
          title: `नोड मेट्नुहोस्`,
          body: `के तपाईं यो नोड मेट्न निश्चित हुनुहुन्छ?`,
          bodyWithLabel: `के तपाईं "{{label}}" मेट्न निश्चित हुनुहुन्छ?`,
          warning: `यो कार्य पूर्ववत गर्न सकिँदैन। यो नोडमा सबै जडानहरू पनि हटाइनेछन्।`,
          cancel: `रद्द गर्नुहोस्`,
          confirm: `मेट्नुहोस्`,
        },
        deleteEdge: {
          title: `जडान मेट्नुहोस्`,
          body: `के तपाईं यो जडान मेट्न निश्चित हुनुहुन्छ?`,
          warning: `यो कार्य पूर्ववत गर्न सकिँदैन।`,
          cancel: `रद्द गर्नुहोस्`,
          confirm: `मेट्नुहोस्`,
        },
        deleteSwitchboard: {
          title: `स्विचबोर्ड मेट्नुहोस्`,
          body: `के तपाईं यो स्विचबोर्ड मेट्न निश्चित हुनुहुन्छ?`,
          bodyWithName: `के तपाईं "{{name}}" मेट्न निश्चित हुनुहुन्छ?`,
          bodyWithId: `के तपाईं स्विचबोर्ड {{id}} मेट्न निश्चित हुनुहुन्छ?`,
          warning: `यो कार्य पूर्ववत गर्न सकिँदैन। सबै स्विचबोर्ड कन्फिगरेसन र डाटा स्थायी रूपमा मेटिनेछ।`,
          cancel: `रद्द गर्नुहोस्`,
          confirm: `मेट्नुहोस्`,
        },
      },
      core: {
        selectExtension: `एक्सटेन्सन छान्नुहोस्...`,
        extensionLabel: `एक्सटेन्सन`,
        selectSchedule: `तालिका छान्नुहोस्...`,
        scheduleLabel: `तालिका`,
        selectSoundClip: `साउन्ड क्लिप छान्नुहोस्...`,
        soundClipLabel: `साउन्ड क्लिप`,
        selectSwitchboard: `स्विचबोर्ड छान्नुहोस्...`,
        switchboardLabel: `स्विचबोर्ड`,
        selectConferenceRoom: `कन्फरेन्स रुम छान्नुहोस्...`,
        conferenceRoomLabel: `कन्फरेन्स रुम`,
        selectQueue: `क्यू छान्नुहोस्...`,
        queueLabel: `क्यू`,
        selectFax: `फ्याक्स एक्सटेन्सन छान्नुहोस्...`,
        faxLabel: `फ्याक्स एक्सटेन्सन`,
        timeoutPlaceholder: `टाइमआउट (सेकेन्ड)`,
        timeoutIncrease: `टाइमआउट बढाउनुहोस्`,
        timeoutDecrease: `टाइमआउट घटाउनुहोस्`,
        expand: `फैलाउनुहोस्`,
        minimize: `न्यूनीकरण गर्नुहोस्`,
        deleteNodeAria: `नोड मेट्नुहोस्`,
        drop: `ड्रप`,
        drag: `ड्र्याग`,
        unnamed: `नाम नभएको`,
        voicemailOptions: {
          definedByExtension: `एक्सटेन्सनद्वारा परिभाषित`,
          systemGenerated: `सिस्टम जनरेट गरिएको अभिवादन`,
          noGreeting: `अभिवादन छैन`,
          busy1: `ब्यस्त-१`,
          unavailable2: `अनुपलब्ध-२`,
          custom3: `अनुकूल-३`,
          custom4: `अनुकूल-४`,
          custom5: `अनुकूल-५`,
          custom6: `अनुकूल-६`,
          custom7: `अनुकूल-७`,
          custom8: `अनुकूल-८`,
          custom9: `अनुकूल-९`,
        },
      },
      create: {
        nameRequired: `नाम आवश्यक`,
        nameRequiredDescription: `कृपया यो स्विचबोर्डको लागि नाम प्रविष्ट गर्नुहोस्।`,
        invalidNumber: `अवैध नम्बर`,
        invalidNumberDescription: `कृपया वैध नम्बर प्रविष्ट गर्नुहोस्।`,
        invalidNumberRange: `नम्बर ० वा १०० र ९९९९९ बीच हुनुपर्छ।`,
        pbxIdRequired: `पीबीएक्स ID आवश्यक`,
        pbxIdRequiredDescription: `स्विचबोर्ड सिर्जना गर्न पीबीएक्स ID आवश्यक छ।`,
        createdSuccess: `स्विचबोर्ड सिर्जना भयो`,
        createFailed: `स्विचबोर्ड सिर्जना गर्न असफल`,
        genericError: `त्रुटि भयो`,
        cannotAddSwitchboard: `स्विचबोर्ड '{{name}}' थप्न सकिँदैन`,
        extensionAlreadyExists: `नम्बर '{{number}}' को एक्सटेन्सन पहिले नै अस्तित्वमा छ।`,
        dialogTitle: `नयाँ स्विचबोर्ड`,
        close: `बन्द गर्नुहोस्`,
        submitButton: `नयाँ स्विचबोर्ड सिर्जना गर्नुहोस्`,
      },
      nodes: {
        clickToConfigure: `कन्फिगर गर्न क्लिक गर्नुहोस्`,
        defaultLabel: `नोड`,
        none: `कुनै होइन`,
        transfer: {
          extension: `एक्सटेन्सन`,
          extensionHelp: `कल ट्रान्सफर गर्न एक्सटेन्सन`,
          timeout: `टाइमआउट (सेकेन्ड)`,
          timeoutHelp: `अर्को नोडमा जानु अघि सेकेन्डमा टाइमआउट`,
          onInvalid: `अवैध मा`,
          onInvalidHelp: `एक्सटेन्सन अवैध भएमा जाने नोड`,
          onTimeout: `टाइमआउट मा`,
          onTimeoutHelp: `ट्रान्सफर टाइमआउट भएमा जाने नोड`,
        },
        wait: {
          duration: `अवधि (सेकेन्ड)`,
          selectDuration: `अवधि छान्नुहोस्...`,
          ringDuringWait: `पर्खदै रिंग गर्नुहोस्`,
        },
        hangUp: {
          noConfig: `यो नोडले कल समाप्त गर्छ। कुनै कन्फिगरेसन आवश्यक छैन।`,
          labelOptional: `लेबल`,
          labelPlaceholder: `प्रदर्शनको लागि लेबल`,
        },
        smsNotification: {
          missedCall: `छुटेको कल`,
          custom: `अनुकूल`,
          messageType: `सन्देश प्रकार`,
          message: `सन्देश`,
          messagePlaceholder: `छुटेको कल {CALLER_ID}-{CALLER_NUMBER} बाट`,
          tooltipNotesTitle: `नोटहरू`,
          tooltipNotesAria: `एसएमएस सन्देश जानकारी`,
          tooltip: {
            intro: `आफ्नै सन्देश बनाउनुहोस्, म्याङ्गो मानहरू समावेश गर्नुहोस्। उदाहरण: ८८८-५५५-१२१२ बाट आउने कल जोन डो कलर आइडीको साथ यसरी प्रविष्ट गरिन्छ`,
            exampleTemplate: `छुटेको कल {CALLER_ID}-{CALLER_NUMBER} बाट`,
            exampleResultLeadIn: `यसले एसएमएस प्राप्तकर्तालाई पठाइने एसएमएस सन्देश यस्तो देखिनेछ`,
            exampleResult: `छुटेको कल जोन डो-८८८५५५१२१२ बाट`,
            variablesHeading: `चलहरू`,
          },
          smsRecipient: `एसएमएस प्राप्तकर्ता`,
          smsRecipientInfo: `एसएमएस प्राप्तकर्ता जानकारी`,
          separateNumbersHint: `धेरै प्राप्तकर्तालाई पठाउन अल्पविरामले नम्बरहरू छुट्याउनुहोस्`,
          or: `वा`,
          autoReplyToCaller: `कलरलाई स्वचालित जवाफ`,
          sendFrom: `यसबाट पठाउनुहोस्`,
          selectSendFrom: `नम्बर चयन गर्नुहोस्...`,
          selectMessagingGroup: `मेसेजिङ समूह छान्नुहोस्...`,
          smsGroupLabel: `एसएमएस समूह:`,
          currentUnavailableNumber: `हालको मान (उपलब्ध छैन): {{value}}`,
          incomingCall: `आउने कल`,
          voicemail: `भ्वाइसमेल`,
        },
        queue: {
          onEscape: `एस्केप मा`,
          maxWait: `अधिकतम पर्खनु:`,
        },
        transferAndRollover: {
          noAnswer: `उत्तर छैन`,
          busy: `ब्यस्त`,
        },
        common: {
          remove: `हटाउनुहोस्`,
          addOption: `+ विकल्प थप्नुहोस्`,
          removeOption: `विकल्प हटाउनुहोस्`,
          tooltip: {
            variablesHeading: `चलहरू`,
            callerIdDesc: `कल गर्ने व्यक्तिको कलर आइडी नाम`,
            callerNumberDesc: `कल गर्ने व्यक्तिको नम्बर`,
            numberDialedDesc: `डायल गरिएको नम्बर`,
            callUidDesc: `कल रेकर्ड पछि खोज्न प्रयोग गर्न सकिने कलको अद्वितीय आइडी।`,
            dialedNumberNameDesc: `म्याङ्गोमा कल गरिएको नम्बरको नाम`,
            timeUtcDesc: `UTC समय क्षेत्रमा कलको समय`,
          },
        },
        schedule: {
          open: `खुल्ला`,
          closed: `बन्द`,
          holiday: `छुट्टी`,
        },
        aiAgent: {
          agentId: `एजेन्ट ID`,
          agentIdPlaceholder: `UUID प्रविष्ट गर्नुहोस् (३६ अक्षर)`,
          onError: `त्रुटि मा`,
          selectAgent: `एजेन्ट चयन गर्नुहोस्...`,
          noAgents: `कुनै एजेन्ट कन्फिगर गरिएको छैन`,
        },
        externalTransfer: {
          transferCompany: `स्थानान्तरण कम्पनी`,
          noCompany: `--`,
          searchTransferCompany: `स्थानान्तरण कम्पनीहरू खोज्नुहोस्...`,
          searchTransferCompanyAriaLabel: `स्थानान्तरण कम्पनीहरू खोज्नुहोस्`,
          noTransferCompanyMatches: `तपाईंको खोजसँग मेल खाने कुनै स्थानान्तरण कम्पनी छैन।`,
          number: `नम्बर`,
          enterPhoneNumber: `फोन नम्बर प्रविष्ट गर्नुहोस्`,
          phoneNumberExactDigitError: `फोन नम्बर ठ्याक्कै {{count}} अङ्कको हुनुपर्छ`,
          phoneNumberDigitRangeError: `फोन नम्बर {{min}} देखि {{max}} अङ्कको हुनुपर्छ`,
          sipServer: `SIP सर्भर`,
          enterSipServer: `SIP सर्भर प्रविष्ट गर्नुहोस्`,
          passThroughCallerId: `कलर ID पास थ्रू गर्नुहोस्`,
          orUseThisCallerId: `वा यो कलर ID प्रयोग गर्नुहोस्`,
          selectCallerId: `कलर ID छान्नुहोस्...`,
          noPhoneNumbersAvailable: `कुनै फोन नम्बर उपलब्ध छैन`,
          requireOneToConnect: `जडान गर्न १ आवश्यक`,
        },
        callDistribution: {
          weight: `वजन`,
          weightWarning: `चेतावनी! कुल वजन प्रतिशत १०० हुनुपर्छ। अहिले {{total}} छ`,
        },
        changeCallerId: {
          callerId: `कलर ID`,
          enterCallerId: `कलर ID प्रविष्ट गर्नुहोस्`,
          addUpTo20Chars: `अगाडि २० वर्ण सम्म थप्नुहोस्`,
          replaceCallerId: `कलर ID प्रतिस्थापन गर्नुहोस्`,
        },
        dialByName: {
          invalid: `अवैध`,
          lookupBy: `यसद्वारा खोज्नुहोस्`,
          extensionName: `एक्सटेन्सन नाम`,
          userName: `प्रयोगकर्ता नाम`,
          sortOrder: `क्रम`,
          firstName: `नाम`,
          lastName: `थर`,
          firstLastName: `नाम/थर`,
        },
        leaveVoicemail: {
          message: `सन्देश`,
        },
        autoAttendant: {
          repeatTimes: `पुनरावृत्ति पटक`,
          allowExtensionDialing: `एक्सटेन्सन डायलिङ अनुमति दिनुहोस्`,
          press: `थिच्नुहोस्`,
        },
        dayNight: {
          whenOpen: `खुल्ला हुँदा`,
          whenClosed: `बन्द हुँदा`,
          open: `खुल्ला`,
          closed: `बन्द`,
          pressToToggle: `(टगल गर्न {{code}} थिच्नुहोस्)`,
          basic: `आधारभूत`,
          advanced: `उन्नत`,
          toggleCode: `टगल कोड`,
          toastSuccess: `पीबीएक्स दिन/रात स्थिति सफलतापूर्वक अपडेट भयो`,
          toastFailed: `पीबीएक्स दिन/रात स्थिति अपडेट गर्न असफल`,
        },
        webhook: {
          tooltipTitle: `के गर्ने?`,
          tooltipAria: `वेबहुक जानकारी`,
          notifyUrl: `सूचना URL`,
          notifyUrlPlaceholder: `http://www.example.com/mango_notification.php`,
          tooltip: {
            intro: `बाह्य वेबसाइट वा सर्भरमा सूचना पठाउन यो सुविधा प्रयोग गर्नुहोस्`,
            exampleUsesHeading: `उदाहरण प्रयोगहरू:`,
            exampleUse1: `स्क्रिन पप सूचना`,
            exampleUse2: `कलहरू लग गर्नुहोस्`,
            exampleUse3: `अर्को साइटमा कार्य गर्नुहोस्`,
            exampleUse4: `लीडहरू सिर्जना गर्नुहोस्`,
            exampleUrlHeading: `उदाहरण URL`,
            curlyBracketsNote: `कर्ली ब्र्याकेटहरू म्याङ्गोभ्वाइसद्वारा वास्तविक डाटासँग प्रतिस्थापन गरिनेछ।`,
          },
        },
        interactiveWebhook: {
          tooltipAria: `इन्टरएक्टिभ वेबहुक जानकारी`,
          url: `URL`,
          urlPlaceholder: `http://www.example.com/webhook`,
          allowExtensionAsOption: `विकल्पको रूपमा एक्सटेन्सन अनुमति दिनुहोस्`,
          option: `विकल्प`,
          optionPlaceholder: `विकल्प`,
          tooltip: {
            intro: `इन्टरएक्टिभ वेबहुकहरूले म्याङ्गो र तपाईंको सफ्टवेयर बीच वास्तविक समयमा रूटिङ अनुमति दिन्छ।`,
            howItWorksHeading: `यसले कसरी काम गर्छ:`,
            howItWorksBody: `म्याङ्गो परिभाषित URL मा GET अनुरोध गर्नेछ। हामी सबै {} चलहरू वास्तविक डाटासँग प्रतिस्थापन गर्नेछौं। कलरलाई कसरी रूट गर्ने भन्ने निर्णय गर्न तपाईं अनुरोधमा प्यारामिटरहरू प्रयोग गर्न सक्नुहुन्छ। यो कलरलाई म्याङ्गोले रूट गर्न चाहनुहुन्छ भन्ने विकल्पको साथ जवाफ पठाएर गरिन्छ। यसले कलरहरूको वास्तविक समय रूटिङ अनुमति दिन्छ।`,
            exampleCasesHeading: `उदाहरण केसहरू:`,
            exampleCase1: `स्किल आधारित रूटिङ`,
            exampleCase2: `प्रारम्भिक कल व्यवस्थापन गर्ने एजेन्टमा ग्राहकहरू फिर्ता रूट गर्नुहोस्`,
            exampleCase3: `फिर्ता कलरहरूको लागि कल रूट अनुकूलन गर्नुहोस्।`,
            exampleRequestHeading: `उदाहरण अनुरोध`,
            responseNote: `जवाफमा विकल्प मान यो वस्तुमा सेट गरिएका विकल्पहरूसँग मेल खानुपर्छ, तपाईं एक्सटेन्सन नम्बर पनि फिर्ता गर्न सक्नुहुन्छ।`,
            exampleResponseHeading: `उदाहरण जवाफ`,
            exampleResponseBody: `{"status": "success", "option": "1"}`,
          },
        },
      },
    },

    faxViewList: {
      titleNoFaxes: `कुनै फ्याक्स छैन`,
      titleNoMatchingFaxes: `कुनै मेल खाने फ्याक्स छैन`,
      subtitleTryRemovingFilters: `कुनै फिल्टर हटाउनुहोस्`,
      subtitleNoFaxes: `कुनै फ्याक्स छैन`,
      buttonTextStartFax: `फ्याक्स शुरू गर्नुहोस्`,
      buttonTextStartFirstFax: `तपाईंको पहिलो फ्याक्स शुरू गर्नुहोस्`,
      searchPlaceholder: `नाम वा नम्बर खोज्नुहोस्`,
      searchLabel: `फ्याक्स खोज्नुहोस्`,
      status: {
        failed: `असफल`,
        pending: `प्रकार`,
        sent: `पठाइएको`,
        received: `प्राप्त गरिएको`,
        unknown: `अज्ञात`,
      },
    },

    call: {
      toast: {
        callDeclined: `{{context}} बाट कल अस्वीकार गरियो`,
        callEnded: `{{context}} संग कल समाप्त भयो`,
        callHeld: `{{context}} संग कल रोकियो`,
        callParked: `{{callName}} {{parkingLotName}} मा स्थानान्तरित गरियो`,
        callParkFailed: `{{callName}} लाई {{parkingLotName}} मा पार्क गर्न असफल`,
        callTargetUndialable: `{{target}} मा कल गर्न सकिँदैन - नम्बर जाँच गरी फेरि प्रयास गर्नुहोस्`,
        callTransferred: `{{callName}} {{transferToName}} मा स्थानान्तरित गरियो`,
        callTransferFailed: `{{callName}} लाई {{transferToName}} मा स्थानान्तरण गर्न असफल`,
        callUnavailable: `फोन विच्छेद भयो - कल गर्न सकिएन`,
      },
    },

    incomingCallModal: {
      newCallFrom: `नयाँ कल बाट`,
      rejectCall: `कल अस्वीकार गर्नुहोस्`,
      acceptCall: `कल स्वीकार गर्नुहोस्`,
      endAndAccept: `समाप्त गर्नुहोस् र स्वीकार गर्नुहोस्`,
      holdAndAccept: `रोकियो गर्नुहोस् र स्वीकार गर्नुहोस्`,
      parkAndAccept: `स्थानान्तरित गर्नुहोस् र स्वीकार गर्नुहोस्`,
    },

    popupCallButtons: {
      accept: `स्वीकार गर्नुहोस्`,
      reject: `अस्वीकार गर्नुहोस्`,
      endAndAccept: `समाप्त गरेर स्वीकार गर्नुहोस्`,
      holdAndAccept: `होल्ड गरेर स्वीकार गर्नुहोस्`,
      parkAndAccept: `पार्क गरेर स्वीकार गर्नुहोस्`,
      switch: `स्विच गर्नुहोस्`,
      resume: `पुनः सुरु गर्नुहोस्`,
      end: `समाप्त गर्नुहोस्`,
      tooltip: {
        accept: `आउने कल स्वीकार गर्नुहोस्`,
        reject: `आउने कल अस्वीकार गर्नुहोस्`,
        endAndAccept: `हालको कल समाप्त गरेर आउने कल स्वीकार गर्नुहोस्`,
        holdAndAccept: `हालको कल होल्डमा राखेर आउने कल स्वीकार गर्नुहोस्`,
        parkAndAccept: `हालको कल पार्क गरेर आउने कल स्वीकार गर्नुहोस्`,
        switch: `यो कलमा स्विच गर्नुहोस्`,
        resume: `यो कल पुनः सुरु गर्नुहोस्`,
        end: `यो कल समाप्त गर्नुहोस्`,
      },
    },

    callStatus: {
      deskPhone: `डेस्क फोन`,
      onHold: `होल्डमा`,
      ringing: `बजिरहेको`,
      connected: `जडान भएको`,
      connecting: `जडान हुँदैछ`,
      ready: `तयार`,
      dialing: `डायल गर्दै...`,
      reconnecting: `पुनः जडान गर्दै...`,
      onDeskPhone: `डेस्क फोनमा`,
      connectedWithDuration: `जडान भएको {{duration}}`,
      shortDial: `डायल`,
      shortRing: `रिङ`,
      shortHold: `होल्ड`,
      shortConn: `जडान`,
      shortDesk: `डेस्क`,
    },

    callAnnouncements: {
      incomingCall: `{{name}}, {{number}} बाट आगमन कल`,
      incomingCallNameOnly: `{{name}} बाट आगमन कल`,
      connected: `जडान भयो`,
      onHold: `होल्डमा`,
      resumed: `कल पुनः सुरु भयो`,
      muted: `म्युट गरियो`,
      unmuted: `अनम्युट गरियो`,
      callEnded: `कल समाप्त भयो`,
      answerFailed: `कल उठाउन सकिएन`,
      holdFailed: `कल होल्डमा राख्न सकिएन`,
      resumeFailed: `कल पुनः सुरु गर्न सकिएन`,
    },

    callSoundIndicator: {
      onHold: `होल्डमा`,
      muted: `म्युट`,
      reconnecting: `पुनः जडान गर्दै`,
    },

    popup: {
      tabs: {
        inboundCalls: `आउने कलहरू`,
        messages: `सन्देशहरू`,
      },
      emptyStates: {
        noCalls: {
          title: `कुनै कल फेला परेन`,
          description: `हाल कुनै आउने कल उपलब्ध छैन`,
        },
        noActiveCalls: `कुनै सक्रिय कल छैन`,
        noMessages: {
          title: `कुनै सन्देश फेला परेन`,
          description: `हाल कुनै सन्देश उपलब्ध छैन`,
        },
      },
      footer: {
        poweredByMango: `Mango Voice द्वारा संचालित`,
      },
      callButtons: {
        deskPhoneActive: `डेस्क फोनमा कल सक्रिय छ`,
        dismiss: `खारेज गर्नुहोस्`,
      },
      callItem: {
        unknownCaller: `अज्ञात कल गर्ने`,
        unknownNumber: `अज्ञात नम्बर`,
        onHold: `होल्डमा`,
        pageIntercom: `पेज/इन्टरकम`,
        callDetails: `कल विवरण`,
      },
      messageButtons: {
        dismiss: `खारेज गर्नुहोस्`,
        openMessage: `सन्देश खोल्नुहोस्`,
      },
      personCard: {
        patientFile: `बिरामी फाइल`,
        fullName: `पूरा नाम`,
        dateOfBirth: `जन्म मिति`,
        patientNumber: `बिरामी नम्बर`,
        inboundNumber: `आउने नम्बर`,
        extension: `विस्तार`,
        defaultLocation: `पूर्वनिर्धारित स्थान`,
        nextAppointment: `अर्को भेट`,
        previousAppointment: `अघिल्लो भेट`,
        insurance: `बीमा`,
        balance: `बाँकी`,
      },
      header: {
        expand: `विस्तार गर्नुहोस्`,
        minimize: `न्यूनीकरण गर्नुहोस्`,
        dismiss: `खारेज गर्नुहोस्`,
        logoAlt: `लोगो`,
      },
    },

    faxPage: {
      toast: {
        copyLinkSuccess: `लिंक क्लिपबोर्डमा प्रतिलिपि गरियो`,
        copyLinkError: `लिंक प्रतिलिपि गर्न असफल`,
        sendSuccess: `तपाईंको फ्याक्स अनुक्रममा थपियो र थुप्रा पठाउनेछ`,
        sendError: `तपाईंको फ्याक्स पठाउन असफल। कृपया पुनः प्रयास गर्नुहोस्`,
        deleteSuccess: `फ्याक्स सफलतापूर्वक मेटियो`,
        deleteError: `फ्याक्स मेटाउन असफल। कृपया पुनः प्रयास गर्नुहोस्`,
        unexpectedError: `अप्रत्याशित त्रुटि भयो`,
      },
      confirmDelete: {
        title: `फ्याक्स मेटाउनुहोस्`,
        message: `के तपाईं यो फ्याक्स मेटाउन चाहनुभएको छ?`,
        button: `मेटाउनुहोस्`,
        cancel: `रद्द गर्नुहोस्`,
      },
      confirmResend: {
        title: `फ्याक्स पुनः पठाउनुहोस्`,
        message: `के तपाईं यो फ्याक्स पुनः पठाउन चाहनुभएको छ?`,
        button: `पुनः पठाउनुहोस्`,
        cancel: `रद्द गर्नुहोस्`,
      },
      emptyStateMessage: `कुनै फ्याक्स छैन`,
      status: {
        queued: `प्रकार`,
        received: `प्राप्त गरिएको`,
        sent: `पठाइएको`,
      },
      direction: {
        to: `लाई`,
        from: `बाट`,
      },
      detailsHeader: {
        status: `{{statusPrefix}} बाट {{statusDate}} अन्तर्गत {{statusTime}} {{directionText}}`,
      },
    },

    pdfToolbar: {
      print: `प्रिन्ट`,
      download: `डाउनलोड`,
      openInNewTab: `नयाँ टुकारा खोल्नुहोस्`,
      firstPage: `पहिलो पृष्ठ`,
      previousPage: `अघिल्लो पृष्ठ`,
      nextPage: `अर्को पृष्ठ`,
      lastPage: `अन्तिम पृष्ठ`,
      rotate: `घुमाउनुहोस्`,
      pageStatus: `{{pages}} मध्ये पृष्ठ {{pageNumber}}`,
    },

    toolbar: {
      clearAll: `सबै साफ गर्नुहोस्`,
      potentialDuplicates: `सम्भावित डुप्लिकेट`,
    },

    schedule: scheduleNe,

    global: {
      close: `बन्द गर्नुहोस्`,
      clearSearch: `खोज खाली गर्नुहोस्`,
      tooltip: {
        copyLink: `क्लिपबोर्डमा लिंक प्रतिलिपि गर्नुहोस्`,
        copyLinkAt: `{{timeStamp}} मा लिंक प्रतिलिपि गर्नुहोस्`,
        copyLinkText: `लिंक प्रतिलिपि गर्नुहोस्`,
      },
      toast: {
        moveSuccess: `भ्वाइसमेल सफलतापूर्वक सारियो।`,
        moveError: `भ्वाइसमेल सार्न असफल।`,
        deleteSuccess: `भ्वाइसमेल मेटाइयो।`,
        deleteError: `भ्वाइसमेल मेटाउन असफल।`,
        markUnreadSuccess: `भ्वाइसमेल अपठित रूपमा चिन्हित गरियो।`,
        markUnreadError: `भ्वाइसमेल अपठित रूपमा चिन्हित गर्न असफल।`,
        copyLinkSuccess: `लिंक क्लिपबोर्डमा प्रतिलिपि गरियो।`,
        copySuccess: `क्लिपबोर्डमा प्रतिलिपि गरियो।`,
        copyError: `क्लिपबोर्डमा प्रतिलिपि गर्न असफल।`,
        extensionSwitched: `एक्सटेन्सन परिवर्तन गरियो:`,
        pbxChanged: `पीबीएक्स परिवर्तन गरियो:`,
        globalPhoneHotKeySuccess: `हट कुञ्जी सफलतापूर्वक बचत गरियो`,
        globalPhoneHotKeyError: `हट कुञ्जी बचत गर्न असफल`,
        globalPhoneHotKeyDisabled: `हटकी असक्षम पारियो।`,
        globalPhoneHotKeyEnabled: `हटकी सक्षम पारियो।`,
      },
      input: {
        defaultPlaceholder: `यो खाली हुनुहुन्छ`,
      },
      timeAgo: {
        justNow: `अहिले`,
        minutesAgo_one: `{{count}} मिनेट अघि`,
        minutesAgo_other: `{{count}} मिनेट अघि`,
        hoursAgo_one: `{{count}} घण्टा अघि`,
        hoursAgo_other: `{{count}} घण्टा अघि`,
        daysAgo_one: `{{count}} दिन अघि`,
        daysAgo_other: `{{count}} दिन अघि`,
      },
      currency: {
        default: `{{value, currency}}`,
        withCode: `{{value, currency, currencyCode}}`,
      },
    },

    contactSearchInput: {
      placeholder: `नाम वा नम्बर टाइप गर्नुहोस्`,
      invalidPhoneNumber: `अवैध फोन नम्बर`,
      noNumber: `नम्बर छैन`,
    },

    newCallModal: {
      header: `नयाँ कल`,
      sendToWebPhone: `वेब फोनमा पठाउनुहोस्`,
      sendToDeskPhone: `डेस्क फोनमा पठाउनुहोस् (Yealink)`,
      from: `बाट`,
      to: `लाई`,
      answerHandsetWhenItRings: `रिंग हुँदा ह्यान्डसेट उठाउनुहोस्।`,
      attemptingToEstablishCallTo: `{{phoneNumber}} मा कल गर्न प्रयास गर्दैछ...`,
      checkInternetConnection: `इन्टरनेट जाँच्नुहोस् र पुनः प्रयास गर्नुहोस्।`,
      tryAgain: `पुनः प्रयास गर्नुहोस्`,
      establishingCallTo: `{{phoneNumber}} मा कल जाँदैछ...`,
      failedToEstablishCallTo: `{{phoneNumber}} मा कल गर्न असफल।`,
    },

    confirmBlockNumberModal: {
      title: `{{formattedPhoneNumber}} लाई ब्लक गर्नुहोस्`,
      message: `तपाईंको पीबीएक्सले अब यो नम्बरबाट कल, सन्देश वा फ्याक्स प्राप्त गर्ने छैन।`,
      confirmText: `नम्बर ब्लक गर्नुहोस्`,
      cancelText: `रद्द गर्नुहोस्`,
      toastBlockError: `{{formattedPhoneNumber}} लाई ब्लक गर्न असफल। कृपया पुनः प्रयास गर्नुहोस्।`,
      toastUnblockError: `{{formattedPhoneNumber}} लाई अनब्लक गर्न असफल। कृपया पुनः प्रयास गर्नुहोस्।`,
    },

    blockedNumbers: {
      addNumber: `नम्बर थप्नुहोस्`,
      headerSubtext: `तल सूचीबद्ध नम्बरहरूबाट आउने सबै कल, सन्देश र फ्याक्सहरू ब्लक गरिनेछ।`,
      header: `ब्लक गरिएको नम्बरहरू`,
      clearButton: `खाली गर्नुहोस्`,
      blockButton: `नम्बर ब्लक गर्नुहोस्`,
      modalSubtext: `तल सूचीबद्ध नम्बरहरूबाट आउने सबै कल, सन्देश र फ्याक्सहरू ब्लक गरिनेछ।`,
      noBlockedNumbers: `कुनै ब्लक गरिएको नम्बर भेटिएन।`,
      unblockTooltip: `अनब्लक गर्नुहोस्`,
      unblockNumberLabel: `{{formattedPhoneNumber}} अनब्लक गर्नुहोस्`,
      numberUnblocked: `{{formattedPhoneNumber}} अनब्लक गरियो`,
      confirmUnblock: {
        title: `{{formattedPhoneNumber}} अनब्लक गर्ने?`,
        message: `तपाईंको PBX ले यो नम्बरबाट फेरि कल, सन्देश र फ्याक्सहरू प्राप्त गर्नेछ।`,
        confirmText: `नम्बर अनब्लक गर्नुहोस्`,
        cancelText: `रद्द गर्नुहोस्`,
      },
    },
    a11y: {
      messages: {
        senderContact: `सम्पर्क`,
        senderYou: `तपाईं`,
        senderTeam: `तपाईंको टोली`,
        messageMeta: `{{sender}}, {{time}}:`,
        newMessage: `{{sender}} बाट नयाँ सन्देश: {{body}}`,
        newMessages: `{{sender}} बाट {{count}} नयाँ सन्देशहरू`,
        attachment: `संलग्न फाइल`,
        messageSent: `सन्देश पठाइयो`,
        messageFailed: `सन्देश पठाउन सकिएन। पुन: प्रयास गर्न सकिन्छ।`,
        openImage: `तस्बिर खोल्नुहोस् {{name}}`,
        imageFrom: `{{sender}} बाट तस्बिर`,
        downloadFile: `{{name}} डाउनलोड गर्नुहोस्`,
      },
      composer: {
        label: `सन्देश`,
        labelWithName: `{{name}} लाई सन्देश`,
      },
      toast: {
        close: `बन्द गर्नुहोस्`,
      },
      nav: {
        notificationCount: `{{count}} नयाँ`,
      },
      filterGroup: {
        text: `टेक्स्ट फिल्टर`,
        voicemail: `भ्वाइसमेल फिल्टर`,
        fax: `फ्याक्स फिल्टर`,
        snippets: `स्निपेट फिल्टर`,
      },
      recipient: {
        label: `प्राप्तकर्ताको नाम वा नम्बर`,
        listLabel: `सुझाव गरिएका सम्पर्कहरू`,
        results: `भेटिएका सम्पर्कहरू: {{count}}`,
      },
    },

    messageInput: {
      statusMessage: {
        uploading: `अपलोड हुँदैछ...`,
        failedToUpload: `अपलोड असफल`,
      },
      attachMedia: `मिडिया संलग्न गर्नुहोस्`,
      addSnippet: `स्निपेट थप्नुहोस्`,
      emojis: `इमोजीहरू 😃`,
      sendText: `सन्देश पठाउनुहोस्`,
      inputPlaceholder: `यहाँ सन्देश पठाउनुहोस्`,
      retry: `पुनः प्रयास गर्नुहोस्`,
    },

    newThreadModal: {
      header: {
        newThread: `नयाँ थ्रेड`,
        noGroupFound: `कुनै समूह भेटिएन`,
      },
      sendButtonText: `पठाउनुहोस्`,
      contactText1: `यो एक्सटेन्सन कुनै मेसेजिङ समूहको हिस्सा होइन।`,
      contactText2: `{{adminUrl}} मा जानुहोस् वा आफ्नो व्यवस्थापकलाई सम्पर्क गर्नुहोस्।`,
      contactLinkText: `सन्देश समूह भनेको के हो?`,
      placeholder: `तपाईंको सन्देश`,
    },

    deleteConfirmModal: {
      title: `भ्वाइसमेल मेटाउनुहोस्?`,
      message: `यो स्थायी हो र पूर्वावस्थामा फर्काउन सकिँदैन।`,
      deleteButton: `मेटाउनुहोस्`,
      cancelButton: `रद्द गर्नुहोस्`,
    },

    confirmModal: {
      defaultTitle: `के तपाईं निश्चित हुनुहुन्छ?`,
      confirmDeleteVoicemail: `यो भ्वाइसमेल मेट्नु स्थायी हो र पूर्वावस्थामा फर्काउन सकिँदैन।`,
      dontAskAgain: `फेरि नसोध्नुहोस्`,
    },

    emptySearch: {
      shoot: `हाय!`,
      nothingIsMatching: `कुनै मेल खाने वस्तु भेटिएन`,
      didYouSpellItRight: `के तपाईंले सहि रूपमा टाइप गर्नुभयो?`,
    },

    messageThreads: {
      emptyState: {
        title: `कुनै सन्देश छैन`,
        subtitle1: `तपाईंले हालसम्म कुनै सन्देश पठाउनुभएको छैन`,
        subtitle2: `सन्देश पठाएर सुरुवात गर्नुहोस्`,
      },
      searchPlaceholder: `नाम वा नम्बर खोज्नुहोस्`,
      searchLabel: `सन्देशहरू खोज्नुहोस्`,
      allGroups: `सबै समूहहरू`,
      new: `{{count}} नयाँ - सबै हेर्नुहोस्`,
      markAllRead: `सबै पढिएको चिन्ह लगाउनुहोस्`,
      buttonText: `नयाँ सन्देश`,
    },

    phoneOptions: {
      recent: `हालसालै`,
      missed: `छुटेका`,
    },

    chatOptions: {
      recent: `हालसालै`,
      unread: `अपठित`,
    },

    snippetOptions: {
      pbx: `पीबीएक्स`,
      personal: `व्यक्तिगत`,
    },

    chatMenu: {
      label: `स्निपेटहरू`,
      settings: `स्निपेट सेटिङहरू`,
    },

    phoneMenu: {
      label: `स्वत: उत्तर`,
    },

    generalMenu: {
      label: `प्रतिक्रिया पठाउनुहोस्`,
    },

    experimentsMenu: {
      label: `वेब फोन`,
    },

    developMenu: {
      notifications: `सूचनाहरू`,
      contacts: `सम्पर्कहरू`,
    },

    callState: {
      inboundAnswered: `प्राप्त कल उठाइयो`,
      outboundAnswered: `पठाइएको कल उठाइयो`,
      inboundMissedOrDeclined: `प्राप्त कल छुट्यो वा अस्वीकार गरियो`,
      outboundMissedOrDeclined: `पठाइएको कल छुट्यो वा अस्वीकार गरियो`,
    },

    voicemailState: {
      received: `भ्वाइसमेल प्राप्त गरियो`,
      sent: `तपाईंले भ्वाइसमेल पठाउनुभयो`,
    },

    voicemailOptions: {
      recent: `हालसालै`,
      unread: `अपठित`,
    },

    mangoPhoneTypes: {
      mobile: `मोबाइल`,
      work: `काम`,
      home: `घर`,
    },

    mangoContactTypes: {
      mango: `मोंगो वोइस`,
    },

    newFaxModal: {
      header: `नयाँ फ्याक्स`,
      footer: {
        sendButtonText: `पठाउनुहोस्`,
      },
      loadingView: {
        sendingFax: `फ्याक्स पठाउनुहोस्...`,
      },
    },

    newFaxForm: {
      dropdownPlaceholder: `बाट...`,
      textAreaPlaceholder: `कवर पृष्ठको नोट टाइप गर्नुहोस्`,
      switchText: {
        includeCoverPage: `कवर पृष्ठ समावेश गर्नुहोस्`,
        sendEmailConfirmation: `इमेल पुनः पठाउनुहोस्`,
      },
      dropzonePlaceholder: `तपाईं २५ मेगाबाइट फ्याक्स पठाउन सक्नुहुन्छ`,
      tagInputPlaceholder: `इमेल पत्ता टाइप गर्नुहोस् र "Enter" टाइप गर्नुहोस्`,
      tagInputGuideText: `तपाईंले अधिकतम {{maxEmailConfirmations}} इमेल पत्ताहरू पठाउन सक्नुहुन्छ`,
      coverPageNoteLabel: `कभर पृष्ठ नोट`,
      emailConfirmationsLabel: `पुष्टि इमेलहरू`,
      emailValueType: `इमेल`,
    },

    sizeGauge: {
      totalSize: `कुल आकार: {{totalSize}} / {{sizeLimit}}`,
      exceededSize: `{{exceededSize}} बाट बाहिर छ`,
    },

    messagingPage: {
      emptyDetailViewMessage: `कुनै थ्रेड चयन गरिएको छैन`,
      errorToastMessage: `अवैध फोन नम्बर`,
      textPlaceholder: {
        receivedFile: `प्राप्त फाइल`,
        fileSent: `फाइल पठाउनुभयो`,
      },
      subheadingText: `{{phoneNumber, phone}} बाट`,
    },

    markReadModal: {
      header: `सावधानी - सबै पढिएको चिन्ह लगाउन`,
      message: `सबै थ्रेडहरू पढिएको चिन्ह लगाउन सकिन्छ भने यो फर्काउन सकिन्छ।`,
      confirmText: `के तपाईं सुन्नुभएको छैन?`,
      confirmButton: `सुन्नुहोस्`,
    },

    listItem: {
      unreadStatus: `अपठित`,
      markedAsUnread: `अपठित रूपमा चिन्हित गरियो`,
      markedAsRead: `पठित रूपमा चिन्हित गरियो`,
    },

    messageThreadHeader: {
      rename: `नाम परिवर्तन गर्नुहोस्`,
      cancel: `रद्द गर्नुहोस्`,
      threadNameLabel: `थ्रेडको नाम`,
    },

    contentDefault: {
      placeholder: `यहाँ फाइल ड्रैग गर्नुहोस् वा क्लिक गर्नुहोस्`,
    },

    contentAcceptedMulti: {
      previewFile: `{{fileName}} पूर्वावलोकन गर्नुहोस्`,
      removeFile: `{{fileName}} हटाउनुहोस्`,
      fileRemoved: `{{fileName}} हटाइयो`,
      moveUp: `{{fileName}} माथि सार्नुहोस्`,
      moveDown: `{{fileName}} तल सार्नुहोस्`,
      fileMoved: `{{fileName}} लाई {{total}} मध्ये स्थान {{position}} मा सारियो`,
      possibleDuplicate: `सम्भावित नक्कल`,
      tooLarge: `धेरै ठूलो`,
      possibleDuplicateAndTooLarge: `सम्भावित नक्कल र धेरै ठूलो`,
      fileWithStatus: `{{file}} – {{status}}`,
    },

    dropZoneMappings: {
      fileToLarge: {
        title: `फाइल बडा`,
        description: `फाइल आपलो अपलोड कर्ता बडा छ। अधिकतम फाइल आकार {{maxFileSize}}MB हो।`,
      },
      fileInvalidType: {
        link: `अधिक जान्नुहोस्`,
        title: `असमर्थित फाइल प्रकार`,
        faxDescription: `फाइल असमर्थित फाइल प्रकार हो। {{link}} समर्थित फाइल प्रकारहरूको बारेमा जान्नुहोस्`,
        description: `फाइल असमर्थित फाइल प्रकार हो। समर्थित फाइल प्रकारहरूको बारेमा जान्नुहोस् {{urlLink}}`,
      },
      fileUploadFailed: {
        title: `अपलोड असफल`,
        description: `फाइल आपलो अपलोड कर्ता असफल भयो। कृपया पुनः प्रयास गर्नुहोस्।`,
      },
      general: {
        title: `अप्रत्याशित त्रुटि भयो`,
        description: `एक अप्रत्याशित त्रुटि भयो। कृपया पुनः प्रयास गर्नुहोस्।`,
      },
    },

    secureFaxPage: {
      logoAlt: `Mango Voice logo`,
      loading: {
        title: `सुरक्षित फ्याक्स लिंक जाँच गर्दै`,
        description: `हामीले यो सुरक्षित फ्याक्स लिंक प्रमाणित गर्दासम्म कृपया पर्खनुहोस्।`,
      },
      password: {
        title: `सुरक्षित फ्याक्स पहुँच`,
        description: `यो सुरक्षित फ्याक्समा पहुँच गर्न सुरक्षित फ्याक्स पासवर्ड प्रविष्ट गर्नुहोस्।`,
        label: `सुरक्षित फ्याक्स पासवर्ड`,
        placeholder: `पासवर्ड प्रविष्ट गर्नुहोस्`,
        submitButton: `सुरक्षित फ्याक्स हेर्नुहोस्`,
        submittingButton: `पासवर्ड प्रमाणित गर्दै...`,
      },
      errors: {
        password_required: `पासवर्ड आवश्यक छ।`,
        invalid_password: `तपाईंले प्रविष्ट गर्नुभएको पासवर्ड गलत छ।`,
        s3_error: `सुरक्षित फ्याक्स पूर्वावलोकन तयार गर्न सकिएन। कृपया पुनः प्रयास गर्नुहोस्।`,
        throttled: `धेरै अनुरोधहरू भए। कृपया एकछिन पर्खेर पुनः प्रयास गर्नुहोस्।`,
        unknown: `केही गलत भयो। कृपया पुनः प्रयास गर्नुहोस्।`,
        attemptsRemaining: `बाँकी प्रयासहरू: {{count}}`,
      },
      status: {
        expired: {
          title: `लिंकको म्याद सकियो`,
          description: `यो सुरक्षित फ्याक्स लिंकको म्याद सकिएको छ। कृपया नयाँ सुरक्षित फ्याक्स लिंक अनुरोध गर्नुहोस्।`,
        },
        disabled: {
          title: `लिंक असक्षम गरियो`,
          description: `यो सुरक्षित फ्याक्स लिंक असक्षम गरिएको छ।`,
        },
        not_found: {
          title: `लिंक फेला परेन`,
          description: `हामीले यो सुरक्षित फ्याक्स लिंक फेला पार्न सकेनौं।`,
        },
        max_downloads_reached: {
          title: `डाउनलोड सीमा पुग्यो`,
          description: `यो सुरक्षित फ्याक्स लिंक आफ्नो अधिकतम डाउनलोड संख्यामा पुगेको छ।`,
        },
        too_many_attempts: {
          title: `धेरै प्रयासहरू`,
          description: `धेरै पटक गलत पासवर्ड प्रयास गरेपछि यो सुरक्षित फ्याक्स लिंक लक गरिएको छ।`,
        },
        throttled: {
          title: `धेरै अनुरोधहरू`,
          description: `यस लिंकका लागि धेरै अनुरोधहरू गरिए। कृपया केही समयपछि पुनः प्रयास गर्नुहोस्।`,
        },
        unknown: {
          title: `सुरक्षित फ्याक्स लोड गर्न सकिएन`,
          description: `हामीले यो सुरक्षित फ्याक्स लिंक प्रमाणित गर्न सकेनौं।`,
        },
        actions: {
          checkAgain: `पुनः जाँच गर्नुहोस्`,
        },
      },
      download: {
        title: `सुरक्षित फ्याक्स तयार छ`,
        description: `तपाईंको सुरक्षित फ्याक्स तयार छ। यो डाउनलोड लिंकको म्याद छिट्टै सकिन्छ, त्यसैले अहिले नै डाउनलोड गर्नुहोस्।`,
        detailsTitle: `फ्याक्स विवरण`,
        fromLabel: `प्रेषक`,
        toLabel: `प्रति`,
        receivedLabel: `प्राप्त गरिएको`,
        downloadsRemainingLabel: `बाँकी डाउनलोडहरू`,
        actions: {
          download: `फ्याक्स डाउनलोड गर्नुहोस्`,
          openInNewTab: `नयाँ ट्याबमा खोल्नुहोस्`,
          tryAnotherPassword: `अर्को पासवर्ड प्रयास गर्नुहोस्`,
        },
        fetchError: {
          title: `पूर्वावलोकन लोड गर्न सकिएन`,
          description: `हामीले डाउनलोड लिंकबाट सुरक्षित फ्याक्स पूर्वावलोकन लोड गर्न सकेनौं।`,
          retryPreview: `पूर्वावलोकन पुनः प्रयास गर्नुहोस्`,
          generic: `सुरक्षित फ्याक्स पूर्वावलोकन लोड गर्न सकिएन।`,
        },
      },
    },

    voicemail: {
      emptyState: {
        title: `कुनै भ्वाइसमेल छैन`,
        subtitle1: `तपाईं सबै कलहरू उठाउँदै हुनुहुन्छ। राम्रो गरिरहनुहोस्!`,
        subtitle2: `यदि तपाईंले भ्वाइसमेल छुटेको अनुभव गर्नुभयो भने समर्थन सम्पर्क गर्नुहोस्।`,
        buttonText: `समर्थन सम्पर्क गर्नुहोस्`,
      },
      searchPlaceholder: `कलर नाम वा नम्बर खोज्नुहोस्`,
      searchLabel: `भ्वाइसमेल खोज्नुहोस्`,
      emptyDetailViewMessage: `कुनै भ्वाइसमेल चयन गरिएको छैन`,

      mangoModal: {
        title: `स्थानान्तरण गर्नुहोस्`,
        headerText: `भ्वाइसमेल सार्नुहोस्`,
        cancelButtonText: `रद्द गर्नुहोस्`,
        moveButtonText: `भ्वाइसमेल सार्नुहोस्`,
        selectVoicemailBoxText: `भ्वाइसमेल बाकस चयन गर्नुहोस्...`,
        markAsUnreadText: `चयन गरिएको बाकसमा अपठित चिन्ह लगाउनुहोस्`,
        destinationBoxText: `गन्तव्य भ्वाइसमेल बाकस`,
        destinationBoxWarning: `यदि तपाईंलाई पहुँच छैन भने यो भ्वाइसमेल अनुपलब्ध हुनेछ।`,
      },

      detailView: {
        headerSubheadingText: `बाट`,
        headerSubheadingToText: `लाई`,
        audioPlayerTitle: `भ्वाइसमेल अडियो`,
        transcriptionText: `ट्रान्सक्रिप्शन`,
      },

      loadingText: `भ्वाइसमेल`,
      transcriptionTitleText: `ट्रान्सक्रिप्शन`,

      move: {
        error: `भ्वाइसमेल सार्न त्रुटि भयो।`,
        success: `भ्वाइसमेल सफलतापूर्वक सारियो`,
        successMarkAsUnread: `भ्वाइसमेल सफलतापूर्वक सारियो र अपठित चिन्ह लगाइयो`,
        successMarkAsRead: `भ्वाइसमेल सफलतापूर्वक सारियो`,
      },

      filter: {
        all: `सबै`,
        unread: `अपठित`,
        allInboxes: `सबै इनबक्सहरू`,
      },

      tooltip: {
        move: `सार्नुहोस्`,
        delete: `मेटाउनुहोस्`,
        markAsUnread: `अपठित चिन्ह लगाउनुहोस्`,
        markAsRead: `पढिएको चिन्ह लगाउनुहोस्`,
        blockNumber: `नम्बर ब्लक गर्नुहोस्`,
        unblockNumber: `नम्बर अनब्लक गर्नुहोस्`,
        copyLink: `लिंक प्रतिलिपि गर्नुहोस्`,
        editContact: `सम्पर्क सम्पादन गर्नुहोस्`,
        newCall: `नयाँ कल`,
        newText: `नयाँ सन्देश`,
        resendFax: `फ्याक्स पुन: पठाउनुहोस्`,
        moveFax: `फ्याक्स सार्नुहोस्`,
        newFax: `नयाँ फ्याक्स`,
        close: `बन्द गर्नुहोस्`,
      },

      copyLinkError: `लिंक प्रतिलिपि गर्न असफल।`,
    },

    audioPlayer: {
      rewind10s: `१० सेकेन्ड पछाडि`,
      play: `प्ले`,
      pause: `पज`,
      mute: `मिउट`,
      unmute: `अनमिउट`,
      fastForward10s: `१० सेकेन्ड अगाडि`,
      jumpToAnswer: `उत्तरमा जानुहोस्`,
      changePlaybackSpeed: `गति परिवर्तन गर्नुहोस्`,
      downloadAudio: `अडियो डाउनलोड गर्नुहोस्`,
      seeKeyboardShortcuts: `किबोर्ड सर्टकट हेर्नुहोस्`,
      mediaError: `अडियो फाइल लोड गर्न समस्या भयो।`,
      noAudio: `कुनै रेकोर्डिङ उपलब्ध छैन।`,
      playbackPosition: `प्लेब्याक स्थिति`,
      playbackPositionValue: `{{duration}} मध्ये {{position}}`,
    },

    fax: {
      filter: {
        all: `सबै`,
        unread: `अपठित`,
        allInboxes: `सबै इनबक्सहरू`,
        sent: `पठाइएको`,
        received: `प्राप्त गरिएको`,
      },
      tooltip: {
        pending: `यो फैक्स प्रशोधन भइरहेको छ र चाँडै पठाइनेछ।`,
      },
    },

    pbxPrompt: {
      loggingIn: `लग इन गर्दै...`,
      loadingPbxs: `पीबीएक्सहरू लोड गर्दै...`,
      selectPbx: `तपाईंको पीबीएक्स चयन गर्नुहोस्`,
      noPbxMessage: `तपाईं हाल कुनै फोन प्रणाली (पीबीएक्स) को सदस्य हुनुहुन्न। यो एप प्रयोग गर्न, कृपया तपाईंको कार्यालयमा फोन प्रणाली व्यवस्थापन गर्ने व्यक्तिलाई सम्पर्क गर्नुहोस् र तपाईंलाई थप्न अनुरोध गर्नुहोस्।`,
      noPbxErrorMessage: `यदि तपाईं यो त्रुटि हो भन्ने विश्वास गर्नुहुन्छ भने, थप सहायताको लागि Mango समर्थनलाई सम्पर्क गर्नुहोस्।`,
      callSupport: `समर्थनलाई कल गर्नुहोस्`,
      emailSupport: `समर्थनलाई इमेल पठाउनुहोस्`,
      back: `पछाडि`,
      errorTitle: `ओहो! केही गलत भयो।`,
      errorMessage: `कृपया पुन: प्रयास गर्नुहोस् वा समर्थनलाई सम्पर्क गर्नुहोस्।`,
    },

    pbxPicker: {
      searchPlaceholder: `पीबीएक्स खोज्नुहोस्...`,
      searchLabel: `पीबीएक्स खोज्नुहोस्`,
      current: `हालको`,
      recent: `हालैका`,
      allPbxs: `सबै पीबीएक्स`,
      searchResults: `खोज परिणामहरू`,
      noResults: `कुनै पीबीएक्स फेला परेन`,
      searchPrompt: `नामद्वारा पीबीएक्स खोज्नुहोस्`,
      switchPbx: `पीबीएक्स स्विच गर्नुहोस्`,
      count: `{{count}} पीबीएक्सहरू`,
      countFiltered: `{{count}} पीबीएक्सहरू फेला पर्यो`,
    },

    pbxHeaderSwitcher: {
      selectPbx: `पीबीएक्स चयन गर्नुहोस्`,
      ariaLabel: `पीबीएक्स स्विच गर्नुहोस्`,
    },

    loginPrompt: {
      loginFailedError: `लग इन असफल भयो। कृपया पुन: प्रयास गर्नुहोस्।`,
      invalidEmail: `अमान्य इमेल ठेगाना!`,
      enterUsername: `कृपया प्रयोगकर्ता नाम प्रविष्ट गर्नुहोस्`,
      enterPassword: `कृपया पासवर्ड प्रविष्ट गर्नुहोस्`,
      invalidCredentials: `अमान्य प्रयोगकर्ता नाम वा पासवर्ड, कृपया आफ्नो प्रमाणहरू जाँच गर्नुहोस् र पुन: प्रयास गर्नुहोस्।`,
      usernamePlaceholder: `इमेल / प्रयोगकर्ता नाम`,
      passwordPlaceholder: `पासवर्ड`,
      logIn: `लग इन`,
      forgotPassword: `तपाईंको पासवर्ड बिर्सनुभयो?`,
      openSupportForm: `सहायता फारम खोल्नुहोस्`,
      backToLogin: `लगइनमा फर्कनुहोस्`,
      showPassword: `पासवर्ड देखाउनुहोस्`,
    },

    desktopAppBanner: {
      tryDesktopApp: `उत्तम अनुभवको लागि {{appName}} डेस्कटोप अनुप्रयोग प्रयास गर्नुहोस्`,
      desktopAppName: `{{appName}} डेस्कटोप`,
      launchAppTooltip: `स्थापित भएमा डेस्कटोप अनुप्रयोग सुरु गर्नुहोस्`,
      downloadAppTooltip: `डेस्कटोप अनुप्रयोग डाउनलोड गर्नुहोस्`,
      launchApp: `अनुप्रयोग सुरु गर्नुहोस्`,
      download: `डाउनलोड`,
      settings: `सेटिङहरू`,
      dontAskAgain: `फेरि नसोध्नुहोस्`,
      remindMeLater: `मलाई पछि सम्झाउनुहोस्`,
      alwaysOpenHint: `लिङ्कहरू सधैं डेस्कटोप अनुप्रयोगमा खोल्न, सेटिङहरूमा यो परिवर्तन गर्नुहोस्।`,
      launchConfirmTitle: `डेस्कटोप अनुप्रयोगमा खोल्नुहोस्`,
    },
    openApp: {
      title: `तपाईंको डेस्कटोप अनुप्रयोग खुल्दै…`,
      subtitle: `हामी अहिले अनुप्रयोग सुरु गर्दैछौं। यदि यो स्वतः खुल्दैन भने, तलको बटन प्रयोग गर्नुहोस्।`,
      closeHint: `अनुप्रयोग खुलेपछि तपाईं यो ट्याब बन्द गर्न सक्नुहुन्छ।`,
      openButton: `डेस्कटोप अनुप्रयोग खोल्नुहोस्`,
      fallbackPrompt: `डेस्कटोप अनुप्रयोग स्थापना गर्नुभएको छैन?`,
      downloadButton: `डेस्कटोप अनुप्रयोग डाउनलोड गर्नुहोस्`,
    },

    openedInDesktop: {
      title: `हामीले यो पृष्ठ डेस्कटोप अनुप्रयोगमा खोल्ने प्रयास गर्यौं`,
      subtitle: `यदि {{appName}} डेस्कटोप अनुप्रयोग खुल्यो भने, तपाईं यो ट्याब बन्द गर्न सक्नुहुन्छ।`,
      continueInBrowser: `ब्राउजरमा जारी राख्नुहोस्`,
      tryAgain: `फेरि प्रयास गर्नुहोस्`,
      stopOpeningInDesktop: `लिङ्कहरू डेस्कटोप अनुप्रयोगमा खोल्न बन्द गर्नुहोस्`,
      settingsHint: `लिङ्कहरू यही ब्राउजरमा राख्न, <settingsLink>सेटिङहरूमा डेस्कटोप अनुप्रयोग</settingsLink> परिवर्तन गर्नुहोस्।`,
    },

    profileSettings: {
      myProfile: `मेरो प्रोफाइल`,
      editProfile: `प्रोफाइल सम्पादन गर्नुहोस्`,
      name: `नाम`,
      username: `प्रयोगकर्ता नाम`,
      email: `इमेल`,
      openDesktopApp: `डेस्कटोप अनुप्रयोग खोल्नुहोस्`,
      launchDesktopApp: `डेस्कटोप अनुप्रयोग लोन गर्नुहोस्`,
      callSupport: `समर्थन कल गर्नुहोस्`,
      emailSupport: `इमेल समर्थन`,
      sendFeedback: `प्रतिक्रिया पठाउनुहोस्`,
      whatsNew: `नयाँ के छ`,
      downloadApp: `अनुप्रयोग डाउनलोड गर्नुहोस्`,
      logOut: `लग आउट`,
      needHelp: `समर्थन चाहिँदैन?`,
      switchPbx: `पीबीएक्स स्विच गर्नुहोस्`,
      pbxName: `पीबीएक्स नाम`,
      darkMode: `डार्क मोड`,
      darkModeOptions: {
        light: `उज्यालो`,
        dark: `अँध्यारो`,
        system: `सिस्टम सेटिङ प्रयोग गर्नुहोस्`,
      },
      language: `भाषा`,
      desktopApp: {
        label: `डेस्कटोप अनुप्रयोग`,
        beta: `बीटा`,
        modeLabel: `जब म यो ब्राउजरमा {{appName}} लिङ्क खोल्छु`,
        modeHint: `यो सेटिङ यो ब्राउजरमा मात्र लागू हुन्छ।`,
        modes: {
          ask: `मलाई सोध्नुहोस् (ब्यानर देखाउनुहोस्)`,
          always: `सधैं डेस्कटोप अनुप्रयोगमा खोल्नुहोस्`,
          never: `नसोध्नुहोस्`,
        },
        testLaunch: {
          title: `लिङ्कहरू डेस्कटोप अनुप्रयोगमा खोल्नुहोस्`,
          question: `हामीले {{appName}} डेस्कटोप अनुप्रयोग खोल्ने प्रयास गर्यौं। के यो खुल्यो?`,
          yes: `हो, खुल्यो`,
          no: `होइन, खुलेन`,
          notOpened: `लिङ्कहरू यही ब्राउजरमा खुल्न जारी रहनेछन्। {{appName}} डेस्कटोप अनुप्रयोग स्थापना गर्नुहोस्, त्यसपछि फेरि प्रयास गर्नुहोस्।`,
          tryAgain: `फेरि प्रयास गर्नुहोस्`,
          close: `बन्द गर्नुहोस्`,
        },
      },
      switchPbxConfirmation: {
        title: `तपाईंको वर्तमान पीबीएक्स परिवर्तन गर्नुहोस्`,
        message: `कल, सन्देश, फ्याक्स र भ्वाइसमेल {{pbxName}} बाट यो अनुप्रयोगमा पहुँच गर्नुभएन जब तपाईं पछि स्विच गर्नुहोस्।`,
        confirmText: `ठीक`,
        cancelText: `रद्द गर्नुहोस्`,
      },
      editMyProfile: {
        title: `मेरो प्रोफाइल सम्पादन गर्नुहोस्`,
        update: `प्रोफाइल अद्यावधिक गर्नुहोस्`,
        close: `बन्द गर्नुहोस्`,
        firstName: `पहिलो नाम`,
        lastName: `थर`,
        username: `प्रयोगकर्ता नाम`,
        email: `इमेल`,
        errRequiredFirstName: `कृपया पहिलो नाम प्रविष्ट गर्नुहोस्।`,
        errRequiredLastName: `कृपया थर प्रविष्ट गर्नुहोस्।`,
        successProfile: `प्रोफाइल सफलतापूर्वक अद्यावधिक गरियो।`,
      },
    },

    pbxQuerySwitch: {
      confirm: {
        title: `यो पीबीएक्स सेट गर्ने हो?`,
        message: `तपाईंको पीबीएक्स {{pbxName}} मा सेट गर्न चाहनुहुन्छ?`,
        confirmText: `पीबीएक्स सेट गर्नुहोस्`,
        cancelText: `रद्द गर्नुहोस्`,
      },
      warning: {
        invalid: {
          title: `अवैध पीबीएक्स लिंक`,
          description: `पीबीएक्स लिंक मान्य छैन। कृपया Admin बाट फेरि प्रयास गर्नुहोस्।`,
        },
        inaccessible: {
          title: `पीबीएक्स स्विच गर्न सकिएन`,
          description: `तपाईंलाई त्यो पीबीएक्समा पहुँच छैन।`,
        },
      },
    },

    languageSelector: {
      title: `भाषा प्राथमिकताहरू`,
      selectLanguage: `भाषा चयन गर्नुहोस्`,
      autoDetect: `स्वत: पत्ता लगाउनुहोस् (प्रणाली भाषा)`,
      languages: {
        en: `अंग्रेजी`,
        'en-US': `अंग्रेजी (संयुक्त राज्य अमेरिका)`,
        'en-GB': `अंग्रेजी (युनाइटेड किंगडम)`,
        'en-CA': `अंग्रेजी (क्यानडा)`,
        es: `स्पेनिश`,
        'es-MX': `स्पेनिश (मेक्सिको)`,
        'es-US': `स्पेनिश (संयुक्त राज्य अमेरिका)`,
        'fr-CA': `फ्रेन्च (क्यानडा)`,
        ko: `कोरियन`,
        ne: `नेपाली`,
        te: `तेलुगु`,
      },
    },

    snippetsSettings: {
      confirmationModal: {
        title: `के सुन्नुहोस्?`,
        message: `यो स्निपेट मेटाउन सकिन्छ र पूर्वावस्थामा फर्काउन सकिँदैन।`,
        confirmText: `मेटाउनुहोस्`,
        cancelText: `रद्द गर्नुहोस्`,
      },
      errorWithTimeout: `कुनै चोटी भयो। कृपया पुनः प्रयास गर्नुहोस्।`,
      headerText: `स्निपेटहरू`,
      newButtonText: `नयाँ`,
      tooltipDelete: `मेटाउनुहोस्`,
      editSnippetLabel: `स्निपेट {{name}} सम्पादन गर्नुहोस्`,
      deleteSnippetLabel: `स्निपेट {{name}} मेटाउनुहोस्`,
      cancelEditing: `सम्पादन रद्द गर्नुहोस्`,
      dismissError: `त्रुटि हटाउनुहोस्`,
      editSnippet: `स्निपेट सम्पादन गर्नुहोस्`,
      newSnippet: `नयाँ स्निपेट`,
      shortcut: `सर्टकट`,
      inputPlaceholder: `शुभप्रभात`,
      shortcutGuideText: `एक शब्द, खाली छैन। उदाहरणको लागि: शुभप्रभात वा परीक्षणपरिणाम`,
      visibility: `दृश्यता`,
      visibilityGuideText: `व्यक्तिगत = केवल तपाईंले पहुँच सक्नुहुन्छ, कंपनी = सबैले पहुँच सक्नुहुन्छ`,
      editBodyInputPlaceholder: `यहाँ एक स्निपेट पठाउनुहोस्। तपाईं इमेल, वेब लिंक, फोन नम्बर थप्न सक्नुहुन्छ।`,
      mangoButtonCancel: `रद्द गर्नुहोस्`,
      mangoButtonSave: `सेव गर्नुहोस्`,
      loadingSnippets: `स्निपेटहरू लोड गर्नुहोस्...`,
      noSnippetsFound: `स्निपेटहरू भेटिएन`,
      personal: `व्यक्तिगत`,
      body: `मुख्यवस्तु`,
      filter: {
        all: `सबै`,
        unread: `अपठित`,
        allInboxes: `सबै इनबक्सहरू`,
      },
    },

    phoneSettings: {
      incomingCalls: `आवागमनकलहरू`,
      showInboundC2CCalls: `इनबाउन्ड C2C कलहरू देखाउनुहोस्`,
      playRingtone: `रिंगटोन बजाउनुहोस्`,
      ringtone: `रिंगटोन`,
      respondWithBusyToSecondCall: `दोश्रो कलमा व्यस्त प्रतिक्रिया दिनुहोस्`,
      disabledInAgentMode: `एजेन्ट मोड सक्षम हुँदा असक्षम पारिएको`,
      outgoingCalls: `प्रस्थानकलहरू`,
      defaultOutboundPhone: `प्रस्थानकलको लागि पूर्वनिर्धारित फोन छान्नुहोस्`,
      autoAnswer: `स्वतःउत्तर`,
      enableCallerIdSelection: `कलर आईडी छनोट सक्षम गर्नुहोस्`,
      enableCallerIdSelectionDescription: `कल गर्दा प्रयोग गर्ने फोन नम्बर छनोट गर्न अनुमति दिन्छ।`,
      callerId: `कलर आईडी`,
      presence: `उपस्थिति`,
      presenceDescription: `तपाईंको वेब फोनमा तलका खण्डहरू देखाइनेछन्, जसले तपाईंका अक्सर डायल गरिने नम्बरहरूमा छिटो पहुँच दिन्छ।`,
      parkingSpotsDisplayed: `पार्किङ स्थानहरू देखाइयो (सीमा ५)`,
      removeParkingSpot: `पार्किङ स्थान हटाउनुहोस्`,
      addParkingSpot: `पार्किङ स्थान थप्नुहोस्`,
      lineExtensionsDisplayed: `लाइन विस्तारहरू देखाइयो (सीमा १०)`,
      removeExtension: `विस्तार हटाउनुहोस्`,
      addExtension: `विस्तार थप्नुहोस्`,
      speedDial: `स्पीड डायल (सीमा {{maxSpeedDials}})`,
      editSpeedDial: `स्पीड डायल सम्पादन गर्नुहोस्`,
      removeSpeedDial: `स्पीड डायल हटाउनुहोस्`,
      addSpeedDial: `स्पीड डायल थप्नुहोस्`,
      clickToCall: `क्लिक-टु-कल`,
      sendToDeskPhone: `डेस्क फोनमा पठाउनुहोस् (Yealink)`,
      useWebPhone: `वेब फोन प्रयोग गर्नुहोस्`,
    },

    phoneSettingItems: {
      selectExtension: `विस्तार छनोट गर्नुहोस्`,
      yourExtension: `तपाईंको विस्तार`,
      activateWebPhone: `वेब फोन सक्षम गर्नुहोस्`,
      confirmationModal: {
        title: `कुनै विस्तार छैन`,
        message1: `तपाईंले यो फोन सिस्टममा कुनै विस्तार नभएको छ ({{pbxName}})।`,
        message2: `फोन सुविधा प्रयोग गर्न कृपया तपाईंको सिस्टम प्रशासकलाई सम्पर्क गर्नुहोस् र विस्तार छनोट गर्नुहोस्।`,
        confirmText: `रद्द गर्नुहोस्`,
        cancelText: `रद्द गर्नुहोस्`,
      },
    },

    extensionSelector: {
      selectExtension: `एक नयाँ विस्तार छनोट गर्नुहोस्`,
      deactivateWebPhone: `वेब फोन सक्षम गर्नुहोस्`,
      none: `कुनै छैन`,
      confirmationModal: {
        title: `उपकरण अनलिङ्क गर्नुहोस्`,
        message: `यो उपकरण अब {{extensionName}} बाट कल पठाउने वा प्राप्त गर्ने छैन।`,
        confirmText: `ठीक`,
        cancelText: `रद्द गर्नुहोस्`,
      },
    },

    webPhone: {
      unknownCaller: `अज्ञात कलर`,
      selectParkingSpot: `पार्किङ स्थान छान्नुहोस्`,
      receivingCalls: `कलहरू प्राप्त गर्दै`,
      doNotDisturb: {
        title: `डिस्टर्ब नगर्नुहोस्`,
        until: `{{time}} सम्म`,
        indefinite: `डिस्टर्ब नगर्नुहोस्`,
        for30Minutes: `३० मिनेटको लागि डिस्टर्ब नगर्नुहोस्`,
        for1Hour: `१ घण्टाको लागि डिस्टर्ब नगर्नुहोस्`,
        for2Hours: `२ घण्टाको लागि डिस्टर्ब नगर्नुहोस्`,
        untilTomorrow: `भोलि सम्म डिस्टर्ब नगर्नुहोस्`,
        turnOff: `डिस्टर्ब नगर्नुहोस् बन्द गर्नुहोस्`,
        optionsLabel: `डिस्टर्ब नगर्नुहोस् विकल्पहरू`,
      },
      tooltip: {
        copied: `कपी भयो!`,
        copyCallerId: `कलर ID कपी गर्नुहोस्`,
        copyPhoneNumber: `फोन नम्बर कपी गर्नुहोस्`,
        endCall: `कल समाप्त गर्नुहोस्`,
        muteCall: `कल म्युट गर्नुहोस्`,
        answerCall: `कल जवाफ दिनुहोस्`,
        switchToCall: `कलमा स्विच गर्नुहोस्`,
        warmTransfer: `गर्म स्थानान्तरण`,
        holdCall: `कल होल्ड गर्नुहोस्`,
        resumeCall: `कल पुनः सुरु गर्नुहोस्`,
        newCall: `नयाँ कल`,
        mergeCalls: `कलहरू मर्ज गर्नुहोस्`,
        endConference: `सम्मेलन समाप्त गर्नुहोस्`,
      },
      callError: {
        youAreDisconnected: `तपाईं डिस्कनेक्ट हुनुभयो`,
        connectionInterrupted: `तपाईंको कनेक्शन बाधित भयो। कनेक्शन पुनः प्रयास गर्न यहाँ क्लिक गर्नुहोस्।`,
        reconnect: `पुन: जडान`,
        connecting: `जडान हुँदै…`,
        connectionFailed: `फोन जडान असफल भयो। कृपया फेरि प्रयास गर्नुहोस्।`,
        retry: `पुन: प्रयास गर्नुहोस्`,
        microphoneDisabled: `माइक्रोफोन अनुमतिहरू असक्षम छन्!`,
        microphoneEnableText: `तपाईंको माइक्रोफोन अनुमति सक्षम गर्दा वेबफोन प्रयोग गर्न सकिन्छ।`,
        microphoneInUse: `माइक्रोफोन प्रयोगमा छ`,
        microphoneInUseText: `अर्को एपले तपाईंको माइक्रोफोन प्रयोग गरिरहेको छ। त्यो (जस्तै Zoom, Teams वा अर्को ट्याब) बन्द गरेर फेरि प्रयास गर्नुहोस्।`,
        seeHereForHelp: `मद्दतको लागि यहाँ हेर्नुहोस्।`,
      },
      feedback: {
        reason: {
          soundDelayed: `आवाज ढिलो भयो`,
          couldntHearOthers: `अरूको आवाज सुन्न सकिनँ`,
          echo: `इको थियो`,
          audioBreakingUp: `अडियो टुक्रिएको थियो`,
          othersCouldntHearMe: `अरूले मेरो आवाज सुन्न सकेनन्`,
          otherAudioIssue: `अन्य अडियो समस्या`,
        },
        modal: {
          header: `के गलत भयो?`,
          dismiss: `खारेज गर्नुहोस्`,
          submit: `प्रतिक्रिया पठाउनुहोस्`,
        },
        toast: {
          header: `आफ्नो कल अडियो मूल्याङ्कन गर्नुहोस्`,
          thanks: `धन्यवाद!`,
          goodQuality: `राम्रो कल गुणस्तर`,
          poorQuality: `खराब कल गुणस्तर`,
          dismiss: `खारेज गर्नुहोस्`,
        },
      },
    },

    faxSettings: {
      enableFaxCoverPage: `फ्याक्स कवर पृष्ठ सक्षम गर्नुहोस्`,
    },

    notificationSettings: {
      alertMessage: `तपाईंले सूचना अवरुद्ध गरिएको छ। तपाईंले आफ्नो ब्राउजर सेटिङ्गहरूमा जानु पर्छ र यो पुनः सक्षम गर्न स्विच गर्न पर्छ।`,
      browserNotifications: `ब्राउजर सूचना`,
      playSoundForNewTexts: `नयाँ सन्देशहरूको लागि आवाज बजाउनुहोस्`,
      testNotification: `सूचना परीक्षण गर्नुहोस्`,
      volumeControl: `सूचनाको आवाज तपाईंको कम्प्युटरमा नियन्त्रित गरियो`,
      help: `सहायता`,
      helpLinkText: `तपाईं सूचना कसरी सक्षम गर्न सक्नुहुन्छ`,
      onGoogleChrome: `Google Chrome मा?`,
      callPop: {
        title: `कल र टेक्स्ट सूचना विन्डो`,
        description: `हाम्रो नयाँ सूचना विन्डो सुविधा प्रयास गर्नुहोस्। यो सुविधाले तपाईंले कल वा टेक्स्ट सन्देश प्राप्त गर्दा एउटा सानो, छुट्टै विन्डो देखाउनेछ। यसले तपाईंलाई आफ्नो काममा बाधा नपुर्‍याई कल र टेक्स्ट जानकारी हेर्न अनुमति दिन्छ!`,
        answerOnPatientInfoButtonClick: `बिरामीको जानकारी खोल्दा कल जवाफ दिनुहोस्`,
        showExampleButton: `उदाहरण देखाउनुहोस्`,
        enableExampleHint: `उदाहरण बटन सक्षम गर्न माथिको स्विच टगल गर्नुहोस्`,
      },
      popupPosition: {
        title: `पपअप विन्डो स्थान`,
        topLeft: `माथि बायाँ`,
        topRight: `माथि दायाँ`,
        bottomLeft: `तल बायाँ`,
        bottomRight: `तल दायाँ`,
      },
    },

    callInProgressModal: {
      title: `कल चलिरहेको छ`,
      message: `कृपया एक्सटेन्शन परिवर्तन गर्नु अघि आफ्नो हालको कल समाप्त गर्नुहोस्`,
      dismiss: `खारेज गर्नुहोस्`,
    },

    sessionExpiredModal: {
      title: `तपाईंको सत्रको म्याद सकियो`,
      message: `तपाईंको सुरक्षाका लागि, तपाईंलाई साइन आउट गरिएको छ। टेक्स्ट सन्देशका ड्राफ्टहरू यस यन्त्रमा सुरक्षित छन्। जारी राख्न फेरि साइन इन गर्नुहोस्।`,
      signInAgain: `फेरि साइन इन गर्नुहोस्`,
    },

    audioSettings: {
      selectSoundOutputSource: `आवाज आउटपुट स्रोत छनोट गर्नुहोस् - स्पीकरहरू`,
      selectInputSource: `इनपुट स्रोत छनोट गर्नुहोस् - माइक्रोफोन`,
      toSelectAudioDevices: `आवाज उपकरणहरू छनोट गर्न कृपया माइक्रोफोन परमिशन दिनुहोस्`,
    },

    integrationsSettings: {
      title: `एकीकरणहरू`,
      description: `यस पृष्ठले तपाईंका केही डेटा स्रोत एकीकरणहरू देखाउँछ — Mango र तपाईंको अभ्यास व्यवस्थापन सफ्टवेयर बीच डेटा सिंक्रोनाइज गर्ने जडानहरू। तपाईंसँग अन्य सक्रिय एकीकरणहरू हुन सक्छन् जुन अझै यहाँ देखिँदैनन्। हामी सबै कुरा एकत्र गर्ने एकीकृत एकीकरण अनुभवमा काम गर्दैछौं।`,
      configuration: `कन्फिगरेसन`,
      auth: `प्राधिकरण`,
      authDescription: `यस एकीकरणले तपाईंको डेटा पहुँच गर्न प्राधिकरण आवश्यक छ।`,
      authButton: `प्राधिकृत गर्नुहोस्`,
      authRegionNotSupported: `तपाईंको पत्ता लगाइएको क्षेत्रमा प्राधिकरण उपलब्ध छैन। यदि तपाईंलाई लाग्छ यो गलत छ (उदाहरणका लागि, यदि तपाईं VPN प्रयोग गर्दै हुनुहुन्छ भने), सहायतासँग सम्पर्क गर्नुहोस्।`,
      agentId: `ID: {{id}}`,
      copiedConfirmation: `प्रतिलिपि गरियो!`,
      copyIdFailedTitle: `ID प्रतिलिपि गर्न सकिएन`,
      unknownDate: `(अज्ञात)`,
      statusActive: `सक्रिय`,
      statusPaused: `रोकिएको`,
      createdLabel: `सिर्जना गरिएको`,
      updatedLabel: `अपडेट गरिएको`,
      notSet: `(सेट गरिएको छैन)`,
      enabled: `सक्षम`,
      disabled: `असक्षम`,
      accessRestricted: `तपाईंसँग एकीकरणहरू पहुँच गर्ने अनुमति छैन। पहुँचका लागि आफ्नो प्रशासकसँग सम्पर्क गर्नुहोस्।`,
      emptyState: {
        primary: `अझै यहाँ कुनै डेटा स्रोत एकीकरणहरू व्यवस्थापन गरिएको छैन।`,
        secondary: `यदि तपाईंसँग सक्रिय एकीकरणहरू छन् भने, तिनीहरू अझै यस सूचीमा देखिँदैनन्।`,
      },
      error: {
        title: `एकीकरणहरू लोड गर्न असफल`,
        message: `तपाईंको एकीकरणहरू लोड गर्दा एउटा त्रुटि आई। कृपया पछि फेरि प्रयास गर्नुहोस्।`,
      },
    },

    updateSettings: {
      noExperimentsAvailable: `यस समयमा कुनै प्रयोगहरू चलिरहेका छैनन्।`,
      channelSwitcher: {
        title: `रिलिज च्यानल स्विचिङ`,
        description: `कुन संस्करणको अपडेटहरू प्राप्त गर्ने छनौट गर्नुहोस्। उत्पादनमा सबैभन्दा स्थिर सुविधाहरू छन्, जबकि अन्य च्यानलहरूले नयाँ सुविधाहरूको पूर्वावलोकन प्रदान गर्न सक्छन्। च्यानल स्विच गर्दा एप्लिकेसन पुनः सुरु गर्न आवश्यक छ।`,
        devModeNote: `विकास मोड: च्यानल स्विचिङ सिमुलेट गरिएको छ र एप पुनः सुरुवात गर्नुको सट्टा पृष्ठ पुनः लोड गर्नेछ।`,
        releaseChannel: `रिलिज च्यानल`,
        selectChannel: `च्यानल छनोट गर्नुहोस्...`,
        switchChannel: `च्यानल स्विच गर्नुहोस्`,
        rollback: `{{channelName}} मा फर्कनुहोस्`,
        current: `हालको: {{channelName}}`,
        switchTo: `मा स्विच गर्नुहोस्:`,
        error: `च्यानल उपलब्ध छैन`,
        validationError: `{{channelName}} मा स्विच गर्न सकिएन। च्यानल अझै उपलब्ध नहुन सक्छ वा नेटवर्क समस्या हुन सक्छ। कृपया पछि पुनः प्रयास गर्नुहोस्।`,
        switchFailed: `च्यानल स्विच गर्न असफल। कृपया फेरि प्रयास गर्नुहोस्।`,
        restartModal: {
          title: `पुनः सुरुवात आवश्यक`,
          successMessage: `सफलतापूर्वक <strong>{{channelName}}</strong> च्यानलमा स्विच गरियो।`,
          warningMessage: `च्यानल स्विच पूरा गर्न एप्लिकेसन अपडेट र त्यसपछि पुनः सुरु गर्न आवश्यक छ। कुनै पनि बचत नगरिएको काम हराउनेछ।`,
          cancel: `रद्द गर्नुहोस्`,
          restartNow: `स्विच सुरु गर्नुहोस्`,
          switchingChannel: `{{channelName}} मा स्विच गर्दै...`,
          checkingUpdates: `अपडेटहरू जाँच गर्दै...`,
          downloadingUpdate: `अपडेट डाउनलोड गर्दै... {{progress}}%`,
          activatingChannel: `च्यानल सक्रिय गर्दै...`,
          switching: `स्विच गर्दै...`,
        },
        highRiskWarning: {
          title: `अस्थिर च्यानल`,
          description: `यस च्यानलमा प्रयोगात्मक सुविधाहरू, त्रुटिहरू, वा अपूर्ण कार्यक्षमता हुन सक्छ। आफ्नै जोखिममा प्रयोग गर्नुहोस्।`,
        },
        mediumRiskWarning: {
          title: `पूर्व-रिलीज च्यानल`,
          description: `यस च्यानलमा पूर्व-रिलीज सफ्टवेयर छ जसमा त्रुटिहरू वा अपूर्ण सुविधाहरू हुन सक्छन्।`,
        },
      },
      releaseNotifications: {
        title: `रिलिज सूचनाहरू`,
        description: `एपको नयाँ संस्करण रिलिज हुँदा इमेल प्राप्त गर्नुहोस्।`,
        descriptionWithChannel: `{{channel}} च्यानलमा एपको नयाँ संस्करण रिलिज हुँदा इमेल प्राप्त गर्नुहोस्।`,
        toggleLabel: `नयाँ रिलिजहरूबारे मलाई इमेल पठाउनुहोस्`,
        recipient: `सूचनाहरू तपाईंको खातासँग सम्बन्धित इमेल ठेगानामा पठाइनेछन्।`,
        recipientWithEmail: `सूचनाहरू {{email}} मा पठाइनेछन्।`,
        resubscribeNote: `तपाईंले पहिले सदस्यता रद्द गर्नुभएको थियो। यसलाई सक्रिय गर्दा तपाईंको इमेल रिलिज अपडेट इमेलहरूमा पुनः सदस्यता लिइनेछ।`,
        error: `तपाईंको सूचना सेटिङ अपडेट गर्न सकिएन। कृपया पुनः प्रयास गर्नुहोस्।`,
        loadError: `तपाईंको सूचना सेटिङ लोड गर्न सकिएन।`,
        retry: `पुनः प्रयास गर्नुहोस्`,
        previewButton: `इमेल पूर्वावलोकन`,
        previewModalTitle: `रिलिज इमेलको उदाहरण`,
        previewModalNote: `तपाईंले प्राप्त गर्ने इमेलको नमुना। वास्तविक सामग्री रिलिज अनुसार फरक हुन्छ। इमेलहरू अङ्ग्रेजीमा पठाइन्छन्।`,
        previewFrom: `प्रेषक:`,
        previewSubject: `विषय:`,
        previewClose: `बन्द गर्नुहोस्`,
        previewTipsTitle: `यी इमेलहरू पाउने कुरा सुनिश्चित गर्नुहोस्`,
        previewSenderTip: `इमेल पठाउने ठेगाना:`,
        previewTipContacts: `त्यो ठेगाना आफ्नो सम्पर्क वा ठेगाना पुस्तिकामा थप्नुहोस्।`,
        previewTipJunk: `रिलिजपछि इमेल देखिएन भने आफ्नो स्प्याम वा जंक फोल्डर जाँच्नुहोस् र त्यसलाई "स्प्याम होइन" भनी चिन्ह लगाउनुहोस्।`,
        previewTipSafelist: `कार्यालयको खातामा, आफ्नो IT प्रशासकलाई mangovoice.com डोमेन सेफलिस्ट गर्न अनुरोध गर्नुहोस्।`,
      },
    },

    blockedNumberModal: {
      header: `नम्बर ब्लक गर्नुहोस्`,
      description: `यो नम्बरबाट आउने सबै कल, सन्देश र फ्याक्सहरू ब्लक गरियो।`,
      clearButton: `साफ गर्नुहोस्`,
      blockButton: `नम्बर ब्लक गर्नुहोस्`,
      inputPlaceholder: `फोन नम्बर प्रविष्ट गर्नुहोस्`,
      inputLabel: `ब्लक गर्ने फोन नम्बर`,
      internationalHint: `विदेशी नम्बरका लागि + र देश कोडबाट सुरु गर्नुहोस्, जस्तै +44।`,
    },

    callCenterSettings: {
      enableAgentMode: `एजेंट मोड सक्षम गर्नुहोस्`,
      customStatuses: `कसरी एजेंट स्थितिहरू`,
      customStatusesDescription: `कसरी स्थितिहरू सेट गर्नुहोस् कल पथमा बाहेक कार्यहरू ट्रैक गर्नुहोस्, जस्तै भोजन, ब्रेक, मीटिङ्ग र अरू। तपाईंको टीमको कार्य संगठित र देखाइनेछ।`,
      editStatus: `स्थिति सम्पादन गर्नुहोस्`,
      deleteStatus: `स्थिति मेटाउनुहोस्`,
      confirmationModal: {
        title: `कसरी स्थिति मेटाउनुहोस्`,
        text1: `तपाईंको कसरी स्थिति, `,
        text2: `, होइरहेको छ। क्या तपाईं सुन्नुहोस्?`,
        confirmText: `स्थिति मेटाउनुहोस्`,
        cancelText: `रद्द गर्नुहोस्`,
      },
      newStatus: `नयाँ स्थिति`,
      toast: {
        deleteStatusSuccess: `स्थिति सफलतापूर्वक मेटाइयो`,
      },
    },

    customStatusModal: {
      NameAddrHeader: `कसरी स्थिति थप्नुहोस्`,
      editHeader: `कसरी स्थिति सम्पादन गर्नुहोस्`,
      inputLabel: `स्थिति नाम`,
      inputPlaceholder: `नाम`,
      type: `प्रकार`,
      typePlaceholder: `प्रकार छनोट गर्नुहोस्`,
      away: `बाहेक`,
      online: `ऑनलाइन`,
      description: `विवरण`,
      descriptionPlaceholder: `यो स्थिति कसरी प्रयोग गरियो?`,
      toast: {
        createSuccess: `स्थिति सफलतापूर्वक थपियो`,
        editSuccess: `स्थिति सफलतापूर्वक सम्पादन गरियो`,
      },
      cancelButton: `रद्द गर्नुहोस्`,
      saveButton: `सेव गर्नुहोस्`,
    },

    experimentsState: {
      queueDashboardEnabled: `क्यू डैशबोर्ड`,
      queueDashboardDescription: `क्यू डैशबोर्ड सुविधा सक्षम गर्नुहोस्।`,
      missedCallsEnabled: `छुटेका कलहरू`,
      missedCallsDescription: `छुटेका कलहरू ट्र्याकिङ सुविधा सक्षम गर्नुहोस्।`,
      badge: {
        beta: `बिटा`,
      },
      globalPhoneCapture: {
        title: `ग्लोबल फोन नम्बर क्याप्चर`,
        description: {
          intro: `तपाईंलाई आफ्नो कम्प्युटरको कुनै पनि एप्लिकेसनबाट फोन नम्बर प्रतिलिपि गर्न र त्यसपछि त्यो नम्बरलाई Mango Voice डायल प्याडमा भर्न हटकी थिच्न अनुमति दिन्छ।`,
          howToUse: `यो सुविधा कसरी प्रयोग गर्ने: पहिले तलको हटकी संयोजन छनोट गर्नुहोस् जुन तपाईं प्रयोग गर्न चाहनुहुन्छ, त्यसपछि "हटकी सेट गर्नुहोस्" बटन थिच्नुहोस्।`,
          afterSet: `एकपटक तपाईंको हटकी सेट भएपछि, कुनै पनि अन्य एप्लिकेसनमा सामान्य रूपमा फोन नम्बर प्रतिलिपि गर्नुहोस् (Cmd/Ctrl+C, वा सन्दर्भ मेनु प्रयोग गरेर), त्यसपछि त्यो नम्बर Mango Voice मा लोड गर्न आफ्नो रोजेको हटकी थिच्नुहोस्।`,
          note: `नोट: केही हटकीहरू अन्य एप्लिकेसनहरूद्वारा प्रयोगमा हुन सक्छन्--Mango ले कुनै पनि द्वन्द्व पत्ता लगाउने प्रयास गर्नेछ र तपाईंलाई थाहा दिनेछ।`,
        },
        activeSettingTitle: `हटकी स्थिति:`,
        activeAndSet: `हालको हटकी`,
        unsavedChanges: `प्रस्तावित हटकी:`,
        configureTitle: `हटकी कन्फिगर गर्नुहोस्:`,
        keyLabel: `कुञ्जी:`,
        status: {
          enabled: `सक्षम पारियो`,
          disabled: `असक्षम पारियो`,
        },
        button: {
          setHotkey: `हटकी सेट गर्नुहोस्`,
          disableFeature: `हटकी असक्षम पार्नुहोस्`,
          enableFeature: `हटकी सक्षम पार्नुहोस्`,
          clearHotkey: `हटकी खाली गर्नुहोस्`,
        },
        notSet: `सेट गरिएको छैन`,
        toast: {
          hotkeyCleared: `हटकी खाली गरियो`,
        },
      },
    },

    shortcutKeysHelp: {
      title: `आवाज खिजर शर्टकटहरू`,
      keyboardKeys: {
        spaceBar: `स्पेस बार`,
        m: `M`,
        leftArrow: `←`,
        rightArrow: `→`,
        slash: `/`,
        shift: `Shift`,
      },
      playPause: `प्ले / पुश`,
      muteUnmute: `म्यूट / अनम्यूट`,
      rewind10s: `रीविंड १० सेकेन्ड`,
      advance10s: `एडवान्स १० सेकेन्ड`,
      rewind3s: `रीविंड ३ सेकेन्ड`,
      advance3s: `एडवान्स ३ सेकेन्ड`,
      scopeNote: `म्युट र स्किप सर्टकटहरू किबोर्ड फोकस अडियो प्लेयरमा हुँदा काम गर्छन्।`,
    },

    newParkingLotModal: {
      header: `पार्किङ स्थान थप्नुहोस्`,
      parkingSpot: `पार्किङ स्थान`,
      label: `लेबल`,
      cancelButton: `रद्द गर्नुहोस्`,
      saveButton: `सेव गर्नुहोस्`,
      parking1Label: `पार्किङ १`,
      parking2Label: `पार्किङ २`,
      parking3Label: `पार्किङ ३`,
      parking4Label: `पार्किङ ४`,
      parking5Label: `पार्किङ ५`,
      parking6Label: `पार्किङ ६`,
      parking7Label: `पार्किङ ७`,
      parking8Label: `पार्किङ ८`,
      parking9Label: `पार्किङ ९`,
      parking10Label: `पार्किङ १०`,
    },

    newExtensionSubscriptionModal: {
      header: `विस्तार उपस्थिति थप्नुहोस्`,
      extension: `विस्तार`,
      cancelButton: `रद्द गर्नुहोस्`,
      saveButton: `सेव गर्नुहोस्`,
    },

    dropdownSelect: {
      placeholder: `छनोट गर्नुहोस्...`,
      noResultsFound: `कुनै परिणाम फेला परेन`,
      assignUserFirst: `पहिले प्रयोगकर्ता तोक्नुहोस्`,
    },

    tooltips: {
      filter: `फिल्टर`,
      dismiss: `हटाउनुहोस्`,
      chartInformation: `चार्ट जानकारी`,
    },

    form: {
      placeholder: {
        searchNameOrNumber: `नाम वा नम्बर खोज्नुहोस्`,
        selectStatus: `स्थिति छनोट गर्नुहोस्`,
        selectUser: `प्रयोगकर्ता छनोट गर्नुहोस्`,
        selectVirtualFax: `भर्चुअल फ्याक्स छान्नुहोस्...`,
        searchNumbers: `नम्बरहरू खोज्नुहोस्`,
        dateMonth: `MM`,
        dateDay: `DD`,
        dateYear: `YYYY`,
        timeHours: `HH`,
        timeMinutes: `MM`,
        timeMeridiem: `AM`,
      },
    },

    newSpeedDialModal: {
      addSpeedDial: `स्पीड डायल थप्नुहोस्`,
      editSpeedDial: `स्पीड डायल सम्पादन गर्नुहोस्`,
      contactName: `संपर्क नाम`,
      number: `नम्बर`,
      cancelButton: `रद्द गर्नुहोस्`,
      saveButton: `सेव गर्नुहोस्`,
    },

    actionsButton: {
      tooltipNewAction: `नयाँ कार्य`,
      newThread: `नयाँ थ्रेड`,
      newCall: `नयाँ कल`,
      newFax: `नयाँ फ्याक्स`,
    },

    accountButton: {
      settings: `सेटिङ्गहरू`,
      connectionStatus: `एप स्थिति`,
      switchPbx: `पीबीएक्स स्विच गर्नुहोस्`,
      openApp: `अनुप्रयोग खोल्नुहोस्`,
      downloadApp: `अनुप्रयोग डाउनलोड गर्नुहोस्`,
      whatsNew: `नयाँ के छ`,
      giveFeedback: `प्रतिक्रिया पठाउनुहोस्`,
      helpCenter: `सहायता केन्द्र`,
      logOut: `लग आउट`,
      apiDocs: `API दस्तावेज`,
    },

    statusPanel: {
      title: `एप स्थिति`,
      tabBasic: `आधारभूत`,
      tabAdvanced: `उन्नत`,
      tabListLabel: `एप स्थिति दृश्यहरू`,
      refresh: `रिफ्रेस गर्नुहोस्`,
      refreshing: `रिफ्रेस गर्दै…`,
      refreshed: `अद्यावधिक भयो`,
      close: `बन्द गर्नुहोस्`,
      copyDiagnostics: `डायग्नोस्टिक प्रतिलिपि गर्नुहोस्`,
      copied: `प्रतिलिपि भयो`,
      overallHealthy: `स्वस्थ`,
      overallDegraded: `ह्रास भएको`,
      overallDown: `डाउन`,
      overallIdle: `निष्क्रिय`,
      overallUnknown: `अज्ञात`,
      summaryGood: `सबै कुरा ठीक देखिन्छ।`,
      summaryProblem: `समस्या फेला पर्‍यो।`,
      fixNetworkOffline: `आफ्नो Wi-Fi वा नेटवर्क केबल जाँच गर्नुहोस्, त्यसपछि फेरि प्रयास गर्नुहोस्।`,
      fixPhoneError: `फोन पुन: जडान गर्न पृष्ठ रिलोड गर्नुहोस्। यदि असफल भइरह्यो भने सपोर्टलाई सम्पर्क गर्नुहोस्।`,
      fixRealtimeReconnecting: `स्वचालित रूपमा पुन: जडान हुँदैछ। यदि यो जारी रह्यो भने पृष्ठ रिलोड गर्नुहोस्।`,
      fixRealtimeSuspended: `एप रोकिएको थियो। यो छिट्टै पुन: सुरु हुनुपर्छ — नभए रिलोड गर्नुहोस्।`,
      fixRealtimeDisconnected: `सन्देश र कल अपडेटहरू पुनर्स्थापना गर्न पृष्ठ रिलोड गर्नुहोस्।`,
      rowInternet: `इन्टरनेट`,
      rowPhoneService: `फोन सेवा`,
      rowMessaging: `सन्देश`,
      rowAppUpdates: `एप अपडेटहरू`,
      stateUpdateReady: `अपडेट तयार छ`,
      stateCantInstallUpdates: `अपडेटहरू इन्स्टल गर्न सकिँदैन`,
      stateUpdateBlocked: `अपडेट अवरुद्ध छ`,
      stateUpdateReadyVersion: `अपडेट तयार छ ({{version}})`,
      stateUpdateDownloading: `अपडेट डाउनलोड हुँदैछ…`,
      stateUpdateDownloadingVersion: `अपडेट डाउनलोड हुँदैछ ({{version}})…`,
      stateUpdateCheckFailed: `अपडेटहरू जाँच गर्न सकिएन`,
      stateCheckingForUpdates: `अपडेटहरू जाँच गर्दै…`,
      stateNotCheckedYet: `अझै जाँच गरिएको छैन`,
      checkAgain: `फेरि जाँच गर्नुहोस्`,
      online: `अनलाइन`,
      offline: `अफलाइन`,
      on: `सक्रिय`,
      off: `निष्क्रिय`,
      stateOnline: `अनलाइन`,
      stateOffline: `अफलाइन`,
      stateConnected: `जडान भयो`,
      stateDisconnected: `जडान विच्छेद भयो`,
      stateRegisteredReady: `दर्ता र तयार`,
      stateConnecting: `जडान हुँदै…`,
      stateReconnecting: `पुन: जडान हुँदै`,
      stateSuspended: `निलम्बित`,
      stateRegistrationError: `दर्ता त्रुटि`,
      regNotStarted: `सुरु भएको छैन`,
      regRegistered: `दर्ता भयो`,
      regUnregistered: `दर्ता रद्द`,
      regTerminated: `समाप्त भयो`,
      transportNotStarted: `सुरु भएको छैन`,
      transportConnected: `जडान भयो`,
      transportDisconnected: `जडान विच्छेद भयो`,
      sectionSip: `SIP`,
      sectionMessaging: `सन्देश / रियल-टाइम`,
      sectionNetwork: `नेटवर्क`,
      sectionTelephony: `टेलिफोनी`,
      sectionEnvironment: `वातावरण`,
      labelRegistration: `दर्ता`,
      labelTransport: `ट्रान्सपोर्ट`,
      labelLastError: `पछिल्लो त्रुटि`,
      labelWebSocket: `WebSocket`,
      labelLastHeartbeat: `पछिल्लो हर्टबिट`,
      heartbeatAgo: `{{seconds}} सेकेन्ड अघि`,
      heartbeatStale: `{{seconds}} सेकेन्ड अघि (पुरानो)`,
      heartbeatNone: `अहिलेसम्म छैन`,
      labelReconnectAttempts: `पुन: जडान प्रयासहरू`,
      labelBrowser: `ब्राउजर`,
      sectionAudio: `अडियो`,
      labelMicPermission: `माइक्रोफोन अनुमति`,
      labelMicInput: `माइक्रोफोन (इनपुट)`,
      labelSpeaker: `स्पिकर (आउटपुट)`,
      deviceCount: `{{count}} फेला पर्‍यो`,
      deviceDefault: `प्रणाली पूर्वनिर्धारित`,
      deviceNone: `कुनै पत्ता लागेन`,
      sectionCall: `सक्रिय कल`,
      callNone: `कुनै सक्रिय कल छैन`,
      labelCallStatus: `स्थिति`,
      labelCallDirection: `दिशा`,
      labelCallSource: `स्रोत`,
      labelCallHold: `होल्डमा`,
      labelCallMuted: `मौन`,
      labelCallDuration: `अवधि`,
      labelLatestVersion: `पछिल्लो संस्करण`,
      labelUpToDate: `अद्यावधिक`,
      labelOutOfDate: `अपडेट उपलब्ध`,
      labelChannel: `च्यानल`,
      labelPlatform: `प्लेटफर्म`,
      sectionSession: `सत्र`,
      labelSignedIn: `साइन इन गरिएको`,
      labelTokenExpiry: `सत्र समाप्त हुन्छ`,
      tokenExpired: `म्याद सकियो`,
      tokenValid: `मान्य`,
      tokenNone: `कुनै सक्रिय सत्र छैन`,
      labelNotifications: `सूचनाहरू`,
      labelLocalStorage: `स्थानीय भण्डारण`,
      storageWritable: `लेख्न योग्य`,
      storageBlocked: `अवरुद्ध`,
      navChipDegraded: `एप स्थिति: ध्यान आवश्यक`,
      navChipDown: `एप स्थिति: समस्या फेला पर्‍यो`,
      navChipAria: `समस्या पत्ता लाग्यो। एप स्थिति खोल्नुहोस्।`,
      sectionEvents: `हालैका जडान घटनाहरू`,
      noEvents: `यस सत्रमा कुनै जडान परिवर्तन छैन — जडान स्थिर रह्यो।`,
      eventOnline: `नेटवर्क अनलाइन`,
      eventOffline: `नेटवर्क अफलाइन`,
      eventWsConnected: `रियल-टाइम जडान भयो`,
      eventWsReconnecting: `रियल-टाइम पुन: जडान हुँदै`,
      eventWsSuspended: `रियल-टाइम निलम्बित`,
      eventWsDisconnected: `रियल-टाइम जडान विच्छेद`,
      labelPbx: `पीबीएक्स`,
      labelPbxId: `पीबीएक्स ID`,
      labelPbxUuid: `पीबीएक्स UUID`,
      labelDoNotDisturb: `बाधा नपुर्‍याउनुहोस्`,
      labelRespondBusy: `दोस्रो कलमा व्यस्त जवाफ दिनुहोस्`,
      labelAppVersion: `एप संस्करण`,
      labelBuild: `बिल्ड`,
      labelCaptured: `क्याप्चर गरिएको`,
      labelUserAgent: `प्रयोगकर्ता एजेन्ट`,
      extensions: `एक्सटेन्सनहरू`,
      noExtensions: `कुनै एक्सटेन्सन नियुक्त गरिएको छैन।`,
      thisSession: `यो सत्र`,
    },

    contactsPage: {
      emptyDetailMessage: `कुनै सम्पर्क चयन गरिएको छैन`,
      toast: {
        copyNumberSuccess: `नम्बर प्रतिलिपि गरिएको`,
        copyNumberError: `नम्बर प्रतिलिपि गर्न असफल`,
      },
    },

    contactsListView: {
      searchPlaceholder: `नाम वा नम्बर खोज्नुहोस्`,
      searchLabel: `सम्पर्कहरू खोज्नुहोस्`,
      contactSourceContent: `सबै सम्पर्कहरू`,
      emptyNotice: {
        noContactsYet: `अझै यहाँ कुनै सम्पर्क छैन`,
        contactSupport: `तपाईंको बिरामी सम्पर्कहरू जडान गर्न हाम्रो सहायता टोलीलाई सम्पर्क गर्नुहोस्। आन्तरिक एक्सटेन्सनहरू पनि यहाँ सेटअप गरिसकेपछि देखिने छन्`,
        noContactsFound: `कुनै सम्पर्क फेला परेन`,
        noMatchingContacts: `हामीले कुनै मिल्ने सम्पर्क फेला पार्न सकेनौं`,
      },
    },

    contactItems: {
      primary: `प्राथमिक`,
      actionButton: {
        copyNumber: `नम्बर प्रतिलिपि गर्नुहोस्`,
        callNumber: `कल नम्बर`,
        messageNumber: `सन्देश नम्बर`,
        sendFax: `फ्याक्स पठाउनुहोस्`,
        callNumberLabel: `{{number}} मा कल गर्नुहोस्`,
        messageNumberLabel: `{{number}} मा सन्देश पठाउनुहोस्`,
        sendFaxLabel: `{{number}} मा फ्याक्स पठाउनुहोस्`,
        copyNumberLabel: `{{number}} प्रतिलिपि गर्नुहोस्`,
        unblockNumberLabel: `{{number}} अनब्लक गर्नुहोस्`,
      },
      emptyContactItem: `यो सम्पर्कको लागि कुनै फोन नम्बर सञ्चालन गरिएको छैन`,
      contactInformation: `सम्पर्क जानकारी`,
      contactSource: `सम्पर्क स्रोत:`,
      fromPms: `{{pmsName}} बाट`,
    },

    contactEventHistory: {
      recentActivity: `हालसालै कार्य`,
      timespanText: `अन्तर्गत १४ दिन`,
      historyLabel: {
        messaging: `सन्देश थ्रेड`,
        inboundCall: `प्राप्त कल`,
        outboundCall: `पठाइएको कल`,
        inboundFax: `प्राप्त फ्याक्स`,
        outboundFax: `पठाइएको फ्याक्स`,
        voicemail: `भ्वाइसमेल`,
      },
    },

    quickDialView: {
      tab: {
        favorites: `पसंदीदा`,
        recentlyDialed: `हालसालै कल`,
      },
      groupName: {
        parkingSpots: `अभियान स्थानहरू`,
        lineExtensions: `लाइन एक्सटेंशनहरू`,
        speedDial: `गति डायल`,
      },
      phoneSettingsFor: `फोन सेटिङ्गहरू: {{group}}`,
    },

    quickDialListItem: {
      empty: {
        parkingSpots: `अभियान स्थानहरू देखाउनको लागि, आपको वेब फोन सेटिङ्गहरू समायोजन गर्नुहोस्`,
        lineExtensions: `यो अभियानमा देखाउनको लागि, कुनै लाइन एक्सटेंशन थप्नुहोस्`,
        speedDial: `तपाईंले गति डायल बाट फेक्नु भएको नम्बरहरू भण्डार गर्नुहोस्`,
        recentlyDialedPrimary: `कुनै हालसालै कल नम्बर छैन`,
        recentlyDialedSecondary: `तपाईंले कल गर्नुभएको बाद हालसालै कल नम्बरहरू यहाँ देखाउनेछन्।`,
      },
      button: {
        webPhoneSettings: `वेब फोन सेटिङ्गहरू`,
        configurePresence: `उपस्थिति समायोजन गर्नुहोस्`,
        configureSpeedDial: `गति डायल समायोजन गर्नुहोस्`,
      },
      parkingLot: {
        title: `अभियान स्थानहरू`,
        subtitle: `अभियान स्थानहरू`,
      },
      tooltip: {
        pickUpCall: `कल उठाउनुहोस्`,
        startCall: `कल सुरु गर्नुहोस्`,
        parkCall: `कल पार्क गर्नुहोस्`,
        newCall: `नयाँ कल सुरु गर्नुहोस्`,
        transferCall: `कल स्थानान्तरण गर्नुहोस्`,
      },
      ariaLabel: {
        startCall: `कल सुरु गर्नुहोस्: {{name}}`,
        startCallWithStatus: `कल सुरु गर्नुहोस्: {{name}}, {{status}}`,
        newCall: `नयाँ कल सुरु गर्नुहोस्: {{name}}`,
        newCallWithStatus: `नयाँ कल सुरु गर्नुहोस्: {{name}}, {{status}}`,
        transferCall: `कल स्थानान्तरण गर्नुहोस्: {{name}}`,
        transferCallWithStatus: `कल स्थानान्तरण गर्नुहोस्: {{name}}, {{status}}`,
        pickUpCall: `कल उठाउनुहोस्: {{name}}, {{status}}`,
        parkCall: `कल पार्क गर्नुहोस्: {{name}}, {{status}}`,
      },
      presence: {
        available: `उपलब्ध`,
        busy: `व्यस्त`,
        ringing: `घण्टी बज्दैछ`,
        occupied: `ओगटिएको`,
        unknown: `अज्ञात`,
      },
    },

    callContactButton: {
      startCall: `कल सुरु गर्नुहोस्`,
      startCallAriaLabel: `कल सुरु गर्नुहोस्: {{name}}, {{number}}`,
      startCallNumberAriaLabel: `कल सुरु गर्नुहोस्: {{number}}`,
      callNumber: `{{number}} मा कल गर्नुहोस्`,
      callNumberWithLabel: `{{number}} मा कल गर्नुहोस् - {{label}}`,
      otherNumbersAriaLabel: `{{name}} का अन्य नम्बरहरू`,
    },

    phoneNumberInput: {
      placeholder: `नम्बर टाइप गर्नुहोस्`,
      clearButton: `साफ गर्नुहोस्`,
      inputLabel: `कल गर्ने फोन नम्बर`,
    },

    phoneNumberMultiDropdown: {
      allNumbers: `सबै नम्बरहरू`,
    },

    phoneSearchInput: {
      placeholder: `नाम वा नम्बर खोज्नुहोस्`,
      clearButton: `साफ गर्नुहोस्`,
      inputLabel: `नाम वा नम्बरले खोज्नुहोस्`,
    },

    contactCardsList: {
      emptySearchText: `नाम वा नम्बर खोज्नुहोस्`,
    },

    outOfCallView: {
      tabButtonDialpad: `डायलपॅड`,
      tabButtonSearch: `खोज्नुहोस्`,
    },

    contactCardList: {
      searchResults: `खोज परिणाम`,
      noMatchingContacts: `तपाईंले खोज्नुभएको सम्पर्कहरू फेला पार्न सकिन्न छैन `,
    },

    callButton: {
      startCall: `कल सुरु गर्नुहोस्`,
      endCall: `कल समाप्त गर्नुहोस्`,
      disabled: `अकार्यकारी`,
      unknown: `अज्ञात`,
    },

    callControlButton: {
      endCall: `कल समाप्त गर्नुहोस्`,
      splitConference: `कल स्थानान्तरण गर्नुहोस्`,
      mergeCalls: `कल समाप्त गर्नुहोस्`,
      newCall: `नयाँ कल सुरु गर्नुहोस्`,
      transfer: `कल स्थानान्तरण गर्नुहोस्`,
      park: `कल पार्क गर्नुहोस्`,
      mute: `मिउट`,
      keypad: `किबोर्ड`,
      hold: `रक्तान्तर`,
      audioSettings: `अडियो सेटिङ्गहरू`,
    },

    onboardingView: {
      welcomeText: `कुनै ब्राउजर बाट कल गर्नुहोस्`,
      bodyText: `कल गर्न, स्थानान्तरण वा अभियान गर्न, अधिक कलहरू प्रबन्धन, पसंदीदा र गति डायल थप्नुहोस्। तपाईंको संचार, तपाईंको रूपमा, कुनै जगभन्नुभएको बाट।`,
      buttonLabel: `फोन सक्रिय गर्नुहोस्`,
      confirmModal: {
        title: `कुनै लाइन एक्सटेंशन उपलब्ध छैन`,
        message1: `तपाईंले यो फोन सिस्टममा कुनै लाइन एक्सटेंशन नयाँ गरिएको छैन {{pbxName}}।`,
        message2: `फोन सुविधा प्रयोग गर्न कृपया तपाईंको सिस्टम प्रबन्धकलाई सम्पर्क गर्नुहोस् र लाइन एक्सटेंशन थप्नुहोस्।`,
        confirmText: `अनगिन्न`,
      },
    },

    callControl: {
      audioSettings: {
        title: `अडियो सेटिङ्गहरू`,
        outputSource: `आउटपुट स्रोत - स्पीकर`,
        inputSource: `इनपुट स्रोत - माइक्रोफोन`,
      },
      parkCall: `कल पार्क गर्नुहोस्`,
      transferCall: `कल स्थानान्तरण गर्नुहोस्`,
    },

    transferTarget: {
      buttonText: `कल स्थानान्तरण गर्नुहोस्`,
      buttonAriaLabel: `कल स्थानान्तरण गर्नुहोस्: {{name}}, {{number}}`,
    },

    transferHeader: {
      placeholder: `नम्बर टाइप गर्नुहोस्`,
      ariaLabel: `कल स्थानान्तरण गर्नुहोस्`,
      inputLabel: `स्थानान्तरण गर्ने नम्बर`,
    },

    parkTarget: {
      buttonText: `कल पार्क गर्नुहोस्`,
      buttonAriaLabel: `कल पार्क गर्नुहोस्: {{name}}`,
    },

    controlDrawer: {
      ariaLabel: `बन्द गर्नुहोस्`,
    },

    dashboardsPage: {
      item: {
        agentStatus: `एजेन्ट स्थिति`,
        eventLog: `घटना लग`,
        inboundAnswerRate: `इनबाउन्ड उत्तर दर`,
        numberComparison: `नम्बर तुलना`,
        extensionComparison: `एक्सटेन्सन तुलना`,
        queueDashboard: `कतार ड्यासबोर्ड`,
      },
      group: {
        callCenter: `कल केन्टर`,
        callDashboards: `कल डैशबोर्ड`,
      },
    },

    queueDashboard: {
      emptyState: {
        title: `कुनै जानकारी फेला परेन`,
        description: `सम्बन्धित डाटा हेर्नको लागि सूचीबाट कतार छान्नुहोस्`,
      },
      filters: {
        title: `कतार`,
        subtitle: `तपाईंको टोलीको कल गतिविधि कसरी तुलना हुन्छ हेर्नुहोस्`,
      },
      queueSelector: {
        placeholder: `सूचीबाट छान्नुहोस्`,
        ariaLabel: `कल कतार छान्नुहोस्`,
      },
      metrics: {
        callersInQueue: `कतारमा कल गर्नेहरू`,
        maxWait: `अधिकतम पर्खाइ समय`,
        averageWait: `औसत पर्खाइ समय`,
        maxAbandoned: `अधिकतम परित्याग`,
        averageAbandoned: `औसत परित्याग`,
        dropRate: `परित्याग दर`,
        answerRate: `उत्तर दर`,
        sampleHistory: `नमूना इतिहास`,
        sampleHistoryAriaLabel: `नमूना इतिहास समय सञ्झ्याल छान्नुहोस्`,
      },
      agentsPanel: {
        title: `एजेन्ट कतार`,
        activeAgents: `सक्रिय एजेन्टहरू`,
        inactiveAgents: `निष्क्रिय एजेन्टहरू`,
        searchPlaceholder: `नाम वा एक्सटेन्सन प्रविष्ट गर्नुहोस्`,
        exportCsv: `सीएसभी निर्यात गर्नुहोस्`,
        exportToast: {
          title: `निर्यात`,
          description: `सीएसभी निर्यात कार्यक्षमता छिट्टै आउनेछ।`,
        },
        loginFailed: {
          title: `लगइन असफल`,
          description: `एजेन्टलाई कतारमा लगइन गर्न असफल भयो। कृपया फेरि प्रयास गर्नुहोस्।`,
        },
        logoutFailed: {
          title: `लगआउट असफल`,
          description: `एजेन्टलाई कतारबाट लगआउट गर्न असफल भयो। कृपया फेरि प्रयास गर्नुहोस्।`,
        },
      },
      callersTable: {
        title: `इनबाउन्ड कतार`,
        callerNumber: `कल गर्ने नम्बर`,
        callerName: `कल गर्नेको नाम`,
        callTime: `कल/पर्खाइ समय`,
        status: `स्थिति`,
        emptyState: {
          title: `कुनै जानकारी फेला परेन`,
          description: `हालको कतारको लागि हाल कुनै जानकारी देखाइरहेको छैन`,
        },
      },
      activeAgentsTable: {
        callerNumber: `कल गर्ने नम्बर`,
        agentName: `एजेन्टको नाम`,
        ext: `एक्सटेन्सन`,
        loggedIn: `लगइन भएको`,
        talkTime: `कुरा गर्ने समय`,
        answered: `उत्तर दिएको`,
        missed: `छुटेको`,
        total: `जम्मा`,
        status: `स्थिति`,
        lastOffered: `अन्तिम प्रस्ताव`,
        action: `कार्य`,
        emptyState: {
          title: `कुनै एजेन्ट फेला परेन`,
          description: `हालको कतारको लागि हाल कुनै जानकारी देखाइरहेको छैन`,
        },
      },
      inactiveAgentsTable: {
        agent: `एजेन्ट`,
        ext: `एक्सटेन्सन`,
        lastLoggedOut: `अन्तिम लगआउट`,
        status: `स्थिति`,
        action: `कार्य`,
        emptyState: {
          title: `कुनै एजेन्ट फेला परेन`,
          description: `हालको कतारको लागि हाल कुनै जानकारी देखाइरहेको छैन`,
        },
      },
      agentRow: {
        changeStatus: `स्थिति परिवर्तन गर्नुहोस्`,
        offline: `अफलाइन`,
      },
      settings: {
        alertHoldTime: `पर्खाइ अलर्ट समय`,
        alertHoldTimeAriaLabel: `पर्खाइ अलर्ट थ्रेसहोल्ड छान्नुहोस्`,
        refreshEvery: `यसको लागि रिफ्रेस गर्नुहोस्`,
        refreshAriaLabel: `रिफ्रेस अन्तराल छान्नुहोस्`,
        seconds_one: `{{count}} सेकेन्ड`,
        seconds_other: `{{count}} सेकेन्ड`,
        minutes_one: `{{count}} मिनेट`,
        minutes_other: `{{count}} मिनेट`,
        hours_one: `{{count}} घण्टा`,
        hours_other: `{{count}} घण्टा`,
      },
      errorDisplay: {
        retrying_one: `{{count}} सेकेन्डमा पुन: प्रयास गर्दै...`,
        retrying_other: `{{count}} सेकेन्डमा पुन: प्रयास गर्दै...`,
        retryNow: `अहिले पुन: प्रयास गर्नुहोस्`,
        retryingButton: `पुन: प्रयास गर्दै...`,
        persistentMessage: `बारम्बार असफलताहरूको कारणले स्वचालित रिफ्रेस रोकिएको छ।`,
      },
      status: {
        ready: `तयार`,
        onCall: `कलमा`,
        ringing: `घण्टी बजिरहेको`,
        available: `उपलब्ध`,
        break: `ब्रेक`,
        waiting: `पर्खिरहेको`,
        answered: `उत्तर दिएको`,
        cancelled: `रद्द गरिएको`,
      },
    },

    inboundAnswerRate: {
      header: `इनबाउंड उत्तर दर`,
      subtitle: `उत्तर दिइएका इनबाउंड कलहरूको प्रतिशत देखाउँछ`,
      filters: {
        dateRange: `मिति दायरा`,
        number: `नम्बर`,
        maxPhoneNumbers: `(अधिकतम {{max}})`,
      },
      counters: {
        answerRate: {
          title: `उत्तर दर`,
          subtitle: `उत्तर दिइएका कलहरूको प्रतिशत`,
        },
        totalCalls: {
          title: `कुल कलहरू`,
          subtitle: `कुल इनबाउंड कलहरू`,
        },
        answered: {
          title: `उत्तर दिइएका कलहरू`,
          subtitle: `कुल उत्तर दिइएका कलहरू`,
        },
        missed: {
          title: `छुटेका कलहरू`,
          subtitle: `कुल छुटेका कलहरू`,
        },
      },
      dashboard: {
        title: `उत्तर दर सारांश`,
        errorText: `कल डाटा लोड गर्न त्रुटि`,
        noDataText: `कल डाटा उपलब्ध छैन`,
        tableViewPlaceholder: `तालिका दृश्य चाँडै आउँदैछ`,
      },
      metrics: {
        answered: `उत्तर दिएको`,
        missed: `उत्तर दिन गरिएको`,
        answerRate: `उत्तर दर`,
      },
      rechartTitle: `कल प्रति {{groupByTitle}}`,
      viewToggle: {
        chart: `चार्ट`,
        table: `तालिका`,
      },
      table: {
        errorLoading: `फोन नम्बर तथ्याङ्क लोड गर्दा त्रुटि भयो`,
        noData: `फोन नम्बर डाटा उपलब्ध छैन`,
        unknown: `अज्ञात`,
        columns: {
          number: `नम्बर`,
          answerRate: `इनबाउंड उत्तर दर`,
          answered: `उत्तर दिइएका कलहरू`,
          missed: `छुटेका कलहरू`,
          total: `कुल कलहरू`,
        },
      },
      invalidDateRange: `अमान्य मिति दायरा`,
      dateRangeTooLarge: `मिति दायरा धेरै ठूलो छ। कृपया ३६५ दिन वा कम को दायरा चयन गर्नुहोस्।`,
      dateRangeAdjustPrompt: `कृपया आफ्नो मिति दायरा समायोजन गर्नुहोस् र पुन: प्रयास गर्नुहोस्।`,
    },

    voicemailLineChart: {
      rechartTitle: `भ्वाइसमेल प्रति {{groupByTitle}}`,
    },

    agentStatusFilters: {
      header: `एजेंट स्थिति`,
      availability: `उपलब्धता`,
      status: `स्थिति`,
      items: {
        online: `अभियान`,
        away: `अन्य`,
      },
    },

    agentStatusTable: {
      agent: `एजेंट`,
      extension: `एक्सटेंशन`,
      currentStatus: `वर्तमान स्थिति`,
      timeInStatus: `स्थितिमा समय`,
      startedAt: `सुरु गरिएको`,
      actions: `कार्य`,
      status: {
        offline: `अकार्यकारी`,
        inQueue: `अभियानमा`,
      },
    },

    agentStatusActions: {
      tooltip: {
        changeStatus: `स्थिति परिवर्तन गर्नुहोस्`,
      },
    },

    eventLog: {
      title: `इभेन्ट लग`,
      filters: {
        allAgents: `सबै एजेन्टहरू`,
        searchAgents: `एजेन्ट खोज्नुहोस्`,
      },
    },

    eventLogTable: {
      when: `कहाँ`,
      who: `कुनै व्यक्ति`,
      status: `स्थिति`,
      inQueue: `अभियानमा`,
      changedBy: `परिवर्तन गर्ने व्यक्ति`,
      yes: `हुन्`,
      no: `हुन्`,
      system: `सिस्टम`,
      unknown: `अज्ञात`,
      failedToLoad: `थप घटनाहरू लोड गर्न असफल भयो।`,
      retry: `पुनः प्रयास गर्नुहोस्`,
      noRecords: `कुनै रेकर्ड फेला परेन।`,
      noRecordsHint: `थप हेर्न आफ्ना फिल्टरहरू समायोजन वा हटाउने प्रयास गर्नुहोस्।`,
    },

    callDetailsOverviewTab: {
      missed: `अनुपलब्ध`,
      answered: `उत्तर दिएको`,
      textButton: `भ्वाइसमेल रिकोर्ड गरिएको`,
    },

    numberComparisonDashboard: {
      invalidDateRange: `अमान्य मिति दायरा`,
      dateRangeTooLarge: `मिति दायरा धेरै ठूलो छ। कृपया ३६५ दिन वा कम को दायरा चयन गर्नुहोस्।`,
      dateRangeAdjustPrompt: `कृपया आफ्नो मिति दायरा समायोजन गर्नुहोस् र पुन: प्रयास गर्नुहोस्।`,
      chartTitle: `नम्बरद्वारा कल मात्रा`,
      showingCount: `{{total}} मध्ये {{displayed}} देखाइँदैछ`,
      showMore: `थप देखाउनुहोस् ({{remaining}} बाँकी)`,
      unknown: `अज्ञात`,
      notAvailable: `उपलब्ध छैन`,
      counters: {
        totalCalls: {
          title: `कुल आगमन कलहरू`,
          subtitle: `सबै नम्बरहरूमा कुल आगमन कलहरू`,
        },
        numberCount: {
          title: `कुल नम्बरहरू`,
          subtitle: `ट्र्याक गरिएका कुल फोन नम्बरहरू`,
        },
        averageCalls: {
          title: `प्रति नम्बर औसत`,
          subtitle: `प्रति नम्बर औसत आगमन कलहरू`,
        },
        topNumber: {
          title: `शीर्ष प्रदर्शनकर्ता`,
        },
      },
      dashboard: {
        errorText: `नम्बर डाटा लोड गर्दा त्रुटि`,
        noDataText: `कुनै नम्बर डाटा उपलब्ध छैन`,
      },
    },

    callDetailData: {
      missed: `अनुपलब्ध`,
      answered: `उत्तर दिएको`,
      inProgress: `अभियानमा`,
      failed: `असफल`,
      direction: {
        inbound: `आगमन`,
        outbound: `निर्गमन`,
        internal: `आन्तरिक`,
      },
    },

    callFilters: {
      buttonTitle: `फिल्टर`,
      sections: {
        direction: `दिशा`,
        outcome: `परिणाम`,
        sentiment: `भावना`,
        status: `स्थिति`,
        callTrait: `कल विशेषता`,
        duration: `अवधि`,
        user: `प्रयोगकर्ता`,
        aiAgent: `AI एजेन्ट`,
      },
      direction: {
        inbound: `आगमन`,
        outbound: `निर्गमन`,
        internal: `आन्तरिक`,
      },
      outcome: {
        missed: `अनुपलब्ध`,
        answered: `उत्तर दिएको`,
      },
      sentiment: {
        office: `कार्यालय`,
        patient: `रोगी`,
        negative: `नकारात्मक`,
        neutral: `तटस्थ`,
        positive: `सकारात्मक`,
      },
      status: {
        inProgress: `अभियानमा`,
        completed: `पूर्ण भयो`,
        failed: `असफल`,
        canceled: `रद्द गरियो`,
        busy: `व्यस्त`,
      },
      callTrait: {
        voicemailRecorded: `भ्वाइसमेल रेकर्ड गरियो`,
        externallyTransferred: `बाहिरी स्थानान्तरण गरियो`,
      },
      duration: {
        longerThan: `भन्दा लामो`,
        shorterThan: `भन्दा छोटो`,
        tenSeconds: `10 सेकेन्ड`,
        oneMinute: `1 मिनेट`,
        fiveMinutes: `5 मिनेट`,
        tenMinutes: `10 मिनेट`,
      },
      user: {
        unknown: `अज्ञात प्रयोगकर्ता`,
      },
      aiAgent: {
        unknown: `अज्ञात AI एजेन्ट`,
      },
    },

    rechartsBarChart: {
      tooltip: {
        modalView: `मोडल देखाउनुहोस्`,
        answerRate: `जवाफ दर:`,
        total: `जम्मा:`,
      },
      noChartData: `कल डाटा उपलब्ध छैन`,
      weekOf: `{{date}} को हप्ता`,
    },

    dateDropdown: {
      today: `आज`,
      yesterday: `कल`,
      last7Days: `अघि 7 दिन`,
      last14Days: `अघि 14 दिन`,
      last30Days: `अघि 30 दिन`,
      thisWeek: `यो सप्ताह`,
      lastWeek: `अघि सप्ताह`,
      thisMonth: `यो मास`,
      lastMonth: `अघि मास`,
      last60Days: `अघि 60 दिन`,
      last90Days: `अघि 90 दिन`,
      customRange: `स्वाभाविक समयावधि`,
    },

    dateTimeRange: {
      after: `{{date}} बाद`,
      before: `{{date}} बाद`,
      selectDateRange: `समयावधि चयन गर्नुहोस्`,
      buttonPlaceholder: `समयावधि चयन गर्नुहोस्`,
    },

    dateTimeRangeModal: {
      after: `बाद `,
      before: `पछाडि `,
      optional: `(वैकल्पिक)`,
      selectDateRange: `समयावधि चयन गर्नुहोस्`,
      buttonPlaceholder: `समयावधि चयन गर्नुहोस्`,
      clearButton: `साफ गर्नुहोस्`,
      setDateRangeButton: `समयावधि सेट गर्नुहोस्`,
      monthLabel: `{{label}} महिना`,
      dayLabel: `{{label}} दिन`,
      yearLabel: `{{label}} वर्ष`,
      hourLabel: `{{label}} घण्टा`,
      minuteLabel: `{{label}} मिनेट`,
      meridiemLabel: `{{label}} पूर्वाह्न/अपराह्न`,
    },

    queueControlButton: {
      inQueue: `अभियानमा`,
      outOfQueue: `अकार्यकारी`,
      doNotDisturb: `अकार्यकारी`,
      online: `अभियान`,
      offline: `अकार्यकारी`,
      joinQueue: `अभियानमा`,
      leaveQueue: `अकार्यकारी`,
      goOffline: `अकार्यकारी`,
    },

    queueStatusMenu: {
      online: `अभियान`,
      away: `अन्य`,
      goOffline: `अकार्यकारी`,
      joinQueue: `अभियानमा`,
    },

    changelogModal: {
      whatsNewLabel: `नयाँ के छ`,
      noResults: `कुनै परिवर्तन लग उपलब्ध छैन`,
      doneButton: `समाप्त`,
      loadingData: `परिवर्तन लग लोड गर्दै...`,
      latest: `(नवीनतम)`,
      releasedLabel: `जारी गरिएको`,
    },

    queueToasts: {
      loggedInToQueue: `कतारमा लग इन भयो`,
      loggedOutOfQueue: `कतारबाट लग आउट भयो`,
      agentStatusUpdated: `एजेन्ट स्थिति अपडेट भयो`,
      unableToUpdateStatus: `स्थिति अपडेट गर्न असमर्थ`,
      queueUpdateErrorMessage: `कृपया यो प्रयोगकर्ता/एक्सटेन्शन एडमिन पोर्टलमा कल कतारमा थपिएको सुनिश्चित गर्नुहोस् वा सहायतालाई सम्पर्क गर्नुहोस्।`,
      genericUpdateErrorMessage: `स्थिति अपडेट गर्दा केही समस्या आयो। कृपया फेरि प्रयास गर्नुहोस् वा सहायतालाई सम्पर्क गर्नुहोस्।`,
      ok: `ठीक`,
    },

    regionSelector: {
      settingsTitle: `म्यांगो डेटा क्षेत्र`,
      settingsDescription: `यसले म्यांगो इकोसिस्टम भित्र तपाईंको डेटा कहाँ राखिएको छ भनेर संकेत गर्छ।`,
      selectRegion: `क्षेत्र छनोट गर्नुहोस्`,
      regionInfoTooltip: `म्यांगो डेटा क्षेत्रलाई जनाउँछ, तपाईंको स्थान होइन।`,
      regions: {
        unitedStates: `संयुक्त राज्य अमेरिका`,
        unitedKingdom: `बेलायत`,
      },
    },

    announcementBanner: {
      infoLabel: `जानकारी घोषणा: {{title}}`,
      warningLabel: `चेतावनी घोषणा: {{title}}`,
      criticalLabel: `गम्भीर घोषणा: {{title}}`,
      dismiss: `घोषणा हटाउनुहोस्`,
      collapse: `घोषणा खुम्च्याउनुहोस्`,
      expand: `घोषणा विस्तार गर्नुहोस्`,
    },
    bannerPager: {
      carousel: `ब्यानरहरू`,
      slide: `{{total}} मध्ये ब्यानर {{current}}`,
      position: `{{current}}/{{total}}`,
      previous: `अघिल्लो ब्यानर`,
      next: `अर्को ब्यानर`,
      carouselRole: `क्यारोसेल`,
      slideRole: `स्लाइड`,
    },

    appVersionBanner: {
      desktopUpdateAvailable: `{{appName}} को बर्सन {{version}} उपलब्ध छ!`,
      webUpdateAvailable: `Mango वेब एप्लिकेसनको नयाँ बर्सन उपलब्ध छ!`,
      restartAndUpdate: `पुन: सुरु गर्नुहोस् र अपडेट गर्नुहोस्`,
      updateNow: `अहिले अपडेट गर्नुहोस्`,
      whatsNew: `नयाँ के छ`,
      remindLater: `पछि सम्झाउनुहोस्`,
      dismiss: `बन्द गर्नुहोस्`,
    },

    clockSkewBanner: {
      message: `तपाईंको यन्त्रको घडी केही मिनेटभन्दा बढी फरक परेको छ। यसले कल, सन्देश र अन्य सुविधाहरूलाई अप्रत्याशित रूपमा व्यवहार गराउन सक्छ। कृपया आफ्नो सिस्टम सेटिङमा मिति र समय स्वतः मिलाउने सुविधा सक्रिय गर्नुहोस्।`,
    },

    updateBlockedBanner: {
      message: `एपले अपडेट पूरा गर्न सकेन। यो प्रायः एन्टिभाइरस वा सुरक्षा सफ्टवेयरले अपडेटलाई रोकेकाले हुन्छ। कृपया आफ्नो IT लाई एप अपडेट हुन अनुमति दिन भन्नुहोस्, वा नवीनतम संस्करण डाउनलोड गर्नुहोस्।`,
      downloadLatest: `नवीनतम संस्करण डाउनलोड गर्नुहोस्`,
    },

    updatePermissionBanner: {
      message: `एप जसरी इन्स्टल गरिएको छ, त्यसका कारण यो कम्प्युटरमा अपडेटहरू इन्स्टल गर्न सकिँदैन। हाम्रो सहायता लेख पालना गर्नुहोस्, वा यसलाई आफ्नो IT टोलीसँग साझा गर्नुहोस्।`,
      howToFix: `कसरी समाधान गर्ने`,
      updateAnyway: `जे भए पनि अपडेट गर्नुहोस्`,
    },

    updateCheck: {
      checkForUpdates: `अपडेट जाँच गर्नुहोस्`,
      restartAndUpdate: `पुनः सुरु गर्नुहोस् र अपडेट गर्नुहोस्`,
      checking: `अपडेट जाँच गर्दै...`,
      upToDate: `अनुप्रयोग अद्यावधिक छ`,
      checkFailed: `अपडेट जाँच असफल`,
      versionAvailable: `बर्सन {{version}} उपलब्ध छ`,
      downloading: `डाउनलोड गर्दै... {{percent}}%`,
      downloaded: `बर्सन {{version}} डाउनलोड भयो`,
      errorOccurred: `अपडेट जाँच गर्दा त्रुटि भयो।`,
    },
    updateRequirement: {
      recommendedMessage: `{{appName}} को नयाँ संस्करण उपलब्ध छ। पछिल्ला सुधारहरू पाउन अपडेट गर्नुहोस्।`,
      recommendedMessageWithDate: `प्रयोग जारी राख्न {{date}} सम्ममा {{appName}} अपडेट गर्नुहोस्।`,
      requiredDuringCall: `{{appName}} को यो संस्करण अब समर्थित छैन। तपाईंको कल सकिएपछि, जारी राख्न तपाईंले अपडेट गर्नुपर्छ।`,
      update: `अपडेट गर्नुहोस्`,
      later: `पछि`,
      downloading: `डाउनलोड हुँदैछ {{percent}}%`,
      restartToUpdate: `अपडेट गर्न पुनः सुरु गर्नुहोस्`,
      downloadInstaller: `इन्स्टलर डाउनलोड गर्नुहोस्`,
      requiredTitle: `अपडेट आवश्यक छ`,
      requiredMessage: `{{appName}} को यो संस्करण ({{currentVersion}}) अब समर्थित छैन। एप प्रयोग जारी राख्न अपडेट गर्नुहोस्।`,
      callsNotice: `तपाईंले अपडेट नगरेसम्म यो एपले कलहरू प्राप्त गर्न सक्दैन। कलहरू तपाईंका अन्य उपकरणहरू, रिङ समूहहरू वा भ्वाइसमेलमा जान्छन्।`,
      preparing: `अपडेट तयार हुँदैछ...`,
      downloadingProgress: `अपडेट डाउनलोड हुँदैछ: {{percent}}%`,
      progressLabel: `अपडेट डाउनलोडको प्रगति`,
      manualInstallMessage: `एपले अपडेट स्वचालित रूपमा इन्स्टल गर्न सक्दैन। नवीनतम संस्करण डाउनलोड गरेर इन्स्टल गर्नुहोस्।`,
      useWebApp: `वेब एप प्रयोग गर्नुहोस्`,
      contactSupport: `सहायतालाई सम्पर्क गर्नुहोस्`,
      alertTitle: `{{appName}} अपडेट गर्नुपर्छ`,
      alertBody: `तपाईंले अपडेट नगरेसम्म कलहरू अन्य उपकरणहरू वा भ्वाइसमेलमा जान्छन्।`,
      copyDownloadLink: `डाउनलोड लिङ्क कपी गर्नुहोस्`,
      linkCopied: `लिङ्क कपी भयो`,
    },

    callDetails: {
      title: `कल विवरणहरू`,
      callTimeline: `कल टाइमलाइन`,
      callFlow: `कल प्रवाह`,
      started: `सुरु भयो`,
      ended: `समाप्त भयो`,
      answerTime: `जवाफ समय`,
      callDuration: `कल अवधि`,
      callOn: `कल मिति`,
      statisticsNotAvailable: `तथ्याङ्कहरू उपलब्ध छैनन्`,
      transcriptNotAvailable: `ट्रान्सक्रिप्ट उपलब्ध छैन`,
      noRecordingAvailable: `कुनै रेकर्डिङ उपलब्ध छैन`,
      callSummary: `कल सारांश`,
      callStatistics: `कल तथ्याङ्क`,
      header: {
        copyLinkToCall: `कल लिंक प्रतिलिपि गर्नुहोस्`,
        copyLinkToCallAtTimestamp: `टाइमस्ट्याम्पमा कल लिंक प्रतिलिपि गर्नुहोस्`,
        downloadAudio: `अडियो डाउनलोड गर्नुहोस्`,
        closePanel: `प्यानल बन्द गर्नुहोस्`,
        expand: `विस्तार गर्नुहोस्`,
        moreActions: `थप कार्यहरू`,
      },
      sections: {
        sentimentByQuarter: {
          title: `क्वार्टर अनुसार भावना`,
          tooltip: `यसले बिरामी र कार्यालयको भावना देखाउँछ, कुराकानीको भावनात्मक टोन प्रतिबिम्बित गर्दै। प्रत्येक क्वार्टर सकारात्मक (हरियो), तटस्थ (खैरो) वा नकारात्मक (रातो) को रूपमा वर्गीकृत गरिएको छ।`,
          agentOverall: `एजेन्ट: {{score}} समग्र`,
          customerOverall: `ग्राहक: {{score}} समग्र`,
          patient: `बिरामी`,
          office: `कार्यालय`,
        },
        officeTalkTime: {
          title: `कार्यालय कुराकानी समय`,
          tooltip: `यो पाई चार्टले कलको समयमा कार्यालयले बोल्ने र सुन्ने समयको विश्लेषण देखाउँछ। आदर्श रूपमा, एजेन्टहरूले बोल्नुभन्दा बढी सुन्ने समय बिताउनुपर्छ, प्रभावकारी ग्राहक अन्तरक्रियाको लागि 50-60% बोल्ने र 40-50% सुन्ने विभाजनको लक्ष्य राखेर।`,
          talking: `बोल्दै`,
          listening: `सुन्दै`,
        },
        officeTalkSpeed: {
          title: `कार्यालय बोल्ने गति`,
          tooltip: `यसले मिनेट प्रति शब्द (wpm) मा कार्यालयको समग्र बोल्ने गति देखाउँछ। सामान्य दायरा 120-150 wpm हो, जुन स्पष्ट र बुझ्न सजिलो छ। 100 wpm भन्दा तलको गतिहरू धेरै ढिलो महसुस हुन सक्छ, जबकि 160 wpm भन्दा माथिको गतिहरू बिरामीहरूका लागि पछ्याउन गाह्रो हुन सक्छ।`,
          wordsPerMinute: `मिनेट प्रति शब्द`,
        },
        interruptions: {
          title: `बाधाहरू`,
          tooltip: `यसले बिरामी र कार्यालयले एक अर्कालाई कति पटक बाधा पुर्‍याए भन्ने विश्लेषण देखाउँछ। कुराकानी कति सहज भयो भनेर मूल्याङ्कन गर्न यो उपयोगी छ।`,
          total: `कुल`,
          patient: `बिरामी`,
          office: `कार्यालय`,
        },
        holdAndPauseTime: {
          title: `होल्ड समय र विरामहरू`,
          tooltip: `यसले कलरले होल्डमा वा मौनमा कति समय बितायो र कुल कलको प्रतिशत देखाउँछ। सामान्य भन्दा लामो प्रतीक्षा समयहरू रातोमा हाइलाइट गरिएको छ।`,
          percentageOfCall: `कलको {{percentage}}%`,
        },
      },
      toast: {
        linkCopied: `लिंक क्लिपबोर्डमा कपी गरियो`,
        linkCopyFailed: `क्लिपबोर्डमा लिंक कपी गर्न असफल।`,
        voicemailTranscriptCopied: `भ्वाइसमेल ट्रान्सक्रिप्ट क्लिपबोर्डमा कपी गरियो।`,
        voicemailTranscriptCopyFailed: `भ्वाइसमेल ट्रान्सक्रिप्ट कपी गर्न असमर्थ।`,
        noVoicemailTranscript: `कपी गर्न कुनै भ्वाइसमेल ट्रान्सक्रिप्ट छैन।`,
        voicemailTranscriptCopyError: `भ्वाइसमेल ट्रान्सक्रिप्ट कपी गर्न असमर्थ। कृपया फेरि प्रयास गर्नुहोस्।`,
        summaryCopied: `सारांश क्लिपबोर्डमा कपी गरियो।`,
        summaryCopyFailed: `सारांश कपी गर्न असमर्थ। कृपया फेरि प्रयास गर्नुहोस्।`,
        noSummary: `कपी गर्न कुनै सारांश छैन।`,
        feedbackThanks: `तपाईंको प्रतिक्रियाको लागि धन्यवाद!`,
        feedbackThumbsUpFailed: `थम्ब्स अप कार्य रिपोर्ट गर्न असफल।`,
        feedbackThumbsDownFailed: `थम्ब्स डाउन कार्य रिपोर्ट गर्न असफल।`,
      },
      voicemail: {
        title: `भ्वाइसमेल`,
        loading: `भ्वाइसमेल ट्रान्सक्रिप्ट लोड हुँदैछ...`,
        accessDenied: `यो भ्वाइसमेल तपाईंसँग पहुँच नभएको इनबक्समा छोडियो। आफ्नो प्रणाली प्रशासकलाई सम्पर्क गर्नुहोस्।`,
        deleted: `भ्वाइसमेल मेटाइएको छ।`,
        notAvailable: `भ्वाइसमेल उपलब्ध छैन।`,
        transcriptionNotAvailable: `भ्वाइसमेल ट्रान्सक्रिप्शन उपलब्ध छैन।`,
      },
      summary: {
        title: `सारांश`,
        processing: `कल ट्रान्सक्रिप्शन प्रशोधन हुँदैछ...`,
        notFound: `कुनै सारांश फेला परेन`,
        notAvailable: `ट्रान्सक्रिप्ट सारांश उपलब्ध छैन।`,
      },
      margoSummary: {
        title: `मार्गो सारांश`,
        copy: `मार्गो सारांश प्रतिलिपि गर्नुहोस्`,
        copied: `मार्गो सारांश प्रतिलिपि गरियो`,
        copySuccess: `मार्गो सारांश क्लिपबोर्डमा प्रतिलिपि गरियो।`,
        copyFailure: `मार्गो सारांश प्रतिलिपि गर्न सकिएन। कृपया फेरि प्रयास गर्नुहोस्।`,
      },
      tabs: {
        overview: `अवलोकन`,
        transcripts: `ट्रान्सक्रिप्टहरू`,
        stats: `तथ्याङ्क`,
      },
      sentiment: {
        title: `भावना`,
        patient: `बिरामी`,
        office: `कार्यालय`,
        positive: `सकारात्मक`,
        negative: `नकारात्मक`,
        neutral: `तटस्थ`,
      },
      tooltip: {
        copyToClipboard: `क्लिपबोर्डमा कपी गर्नुहोस्`,
        goToVoicemail: `भ्वाइसमेलमा जानुहोस्`,
        accurate: `सही`,
        inaccurate: `गलत`,
        copyLinkToSearch: `खोजमा लिंक कपी गर्नुहोस्`,
        fullscreen: `पूर्ण स्क्रिन`,
      },
    },

    calls: {
      searchLabel: `कलहरू खोज्नुहोस्`,
      export: {
        button: `सीएसभी निर्यात`,
        starting: `सुरु हुँदैछ...`,
        preparing: `निर्यात तयारी गर्दै...`,
        processing: `निर्यात गर्दै...`,
        completed: `निर्यात भयो`,
        success: `सीएसभी डाउनलोड सुरु भयो`,
        successTruncated: `निर्यात पूरा भयो (परिणामहरू 10 लाख पङ्क्तिमा सीमित)`,
        error: `निर्यात असफल`,
        errorTooMany: `धेरै निर्यातहरू चलिरहेका छन्। कृपया पर्खनुहोस् र फेरि प्रयास गर्नुहोस्।`,
        errorInvalid: `अवैध निर्यात मापदण्डहरू।`,
        errorNotFound: `निर्यात कार्य भेटिएन। सर्भर पुनः सुरु भएको हुन सक्छ। कृपया पुनः प्रयास गर्नुहोस्।`,
        errorGeneric: `निर्यात सुरु गर्न असफल।`,
        errorStatusCheck: `निर्यात स्थिति जाँच गर्न असफल।`,
        toastProcessingTitle: `निर्यात प्रगतिमा`,
        toastProcessingDescription: `तपाईंको सीएसभी तयार भइरहेको छ। डाउनलोड स्वचालित रूपमा सुरु हुनेछ।`,
        unsupportedFiltersHeader: `सीएसभी निर्यातले यी फिल्टरहरूलाई समर्थन गर्दैन:`,
        filterSearch: `खोज`,
      },
      transcriptCell: {
        noTranscriptAvailable: `ट्रान्सक्रिप्ट उपलब्ध छैन.`,
        inProgress: `ट्रान्सक्रिप्ट तयार हुँदैछ, पछि फेरि जाँच गर्नुहोस्.`,
        audioTooLong: `ट्रान्सक्रिप्ट उपलब्ध छैन: कल अडियो धेरै लामो थियो.`,
        viewTranscript: `ट्रान्सक्रिप्ट हेर्नुहोस्`,
        noTranscript: `ट्रान्सक्रिप्ट उपलब्ध छैन`,
        transcriptInProgress: `ट्रान्सक्रिप्ट तयार हुँदैछ`,
        transcriptUnavailable: `ट्रान्सक्रिप्ट उपलब्ध छैन`,
        openVoicemail: `भ्वाइसमेल खोल्नुहोस्`,
      },
      detail: {
        notFound: `उफ्, यो रेकर्ड मेटिएको छ वा अवस्थित छैन. मद्दत चाहिन्छ भने समर्थनलाई सम्पर्क गर्नुहोस्.`,
        unknownNumber: `अज्ञात नम्बर`,
        unknownSource: `अज्ञात`,
      },
    },

    missedCalls: {
      emptyState: `छुटेका कलहरू छैनन्`,
      emptyStateSubtitle: `सबै कलहरू जवाफ दिइएको छ`,
      description: `छुटेका कलहरू ट्र्याक र व्यवस्थापन गर्नुहोस्`,
      instructions: `विशिष्ट छुटेका कलहरू फेला पार्न फिल्टर र मिति दायरा प्रयोग गर्नुहोस्`,
      errorLoadingMissedCalls: `छुटेका कलहरू लोड गर्दा त्रुटि`,
      pleaseTryAgainLater: `कृपया पछि फेरि प्रयास गर्नुहोस्`,
      countLabel: `{{count}} छुटेका कलहरू`,
      refresh: `रिफ्रेश गर्नुहोस्`,
      followUpStatus: {
        open: `खुला`,
        returnedCallBack: `फिर्ता - फेरि कल गर्नुहोस्`,
        returnedSMS: `फिर्ता - एसएमएस`,
        returnedVoicemail: `फिर्ता - भ्वाइसमेल`,
        returnedEmail: `फिर्ता - इमेल`,
        returnedNoAnswer: `फिर्ता - जवाफ छैन`,
        noFollowUpRequired: `कुनै पछिल्लो कार्य आवश्यक छैन`,
        assignUserFirst: `पहिले प्रयोगकर्ता असाइन गर्नुहोस्`,
      },
      filters: {
        sections: {
          type: `प्रकार`,
          status: `स्थिति`,
          user: `प्रयोगकर्ता`,
          phoneNumber: `फोन नम्बर`,
        },
        type: {
          voicemail: `भ्वाइसमेल`,
          abandoned: `छोडिएको`,
        },
        userFallback: `प्रयोगकर्ता {{id}}`,
      },
      assignedUser: {
        loading: `लोड हुँदै...`,
        loadingShort: `लोड हुँदै`,
        unassigned: `असाइन नगरिएको`,
        userFallback: `प्रयोगकर्ता {{id}}`,
      },
      type: {
        voicemailAlt: `भ्वाइसमेल`,
        abandonedAlt: `छोडिएको`,
        abandonedTitle: `छोडिएको`,
        abandonedDescription: `कलको जवाफ दिइएन र ग्राहकले भ्वाइसमेल छोडेनन्`,
      },
    },

    callsList: {
      noCallsFound: `कुनै कलहरू फेला परेनन्`,
      tryDifferentFilters: `फरक फिल्टरहरू प्रयास गर्नुहोस्`,
    },

    callsTable: {
      label: `कलहरू`,
      openCallDetails: `कल विवरण हेर्नुहोस्, {{time}} {{date}}`,
      columns: {
        dateTime: `मिति र समय`,
        outcome: `परिणाम`,
        to: `प्रति`,
        from: `बाट`,
        toFrom: `प्रति/बाट`,
        duration: `अवधि`,
        transcript: `ट्रान्सक्रिप्ट`,
      },
    },

    missedCallsTable: {
      columns: {
        dateTime: `मिति र समय`,
        from: `बाट`,
        to: `प्रति`,
        type: `प्रकार`,
        followUpTime: `पछिल्लो समय`,
        followUpStatus: `पछिल्लो स्थिति`,
        assignedTo: `तिर असाइन गरिएको`,
        action: `कार्य`,
      },
    },

    contactInfoCard: {
      callTarget: {
        from: `बाट`,
        to: `प्रति`,
      },
      tooltip: {
        call: `कल`,
        message: `सन्देश`,
        sendFax: `फ्याक्स पठाउनुहोस्`,
        blockNumber: `नम्बर ब्लक गर्नुहोस्`,
        unblockNumber: `नम्बर अनब्लक गर्नुहोस्`,
      },
    },

    contactCell: {
      menu: {
        callNumber: `नम्बर कल गर्नुहोस्`,
        copyNumber: `नम्बर प्रतिलिपि गर्नुहोस्`,
        messageNumber: `नम्बर सन्देश`,
        sendFax: `फ्याक्स पठाउनुहोस्`,
        blockNumber: `नम्बर ब्लक गर्नुहोस्`,
        unblockNumber: `नम्बर अनब्लक गर्नुहोस्`,
        moreOptions: `थप विकल्पहरू`,
        moreOptionsFor: `{{name}} का लागि थप विकल्पहरू, {{time}} {{date}}`,
      },
    },

    reportingFilters: {
      dateRange: `मिति दायरा`,
      number: `नम्बर`,
      maxPhoneNumbers: `(अधिकतम {{max}})`,
    },

    numberComparisonFilters: {
      numberComparison: `नम्बर तुलना`,
      subtitle: `फोन नम्बरहरूमा आगमन कल मात्रा तुलना गर्नुहोस्`,
      dateRange: `मिति दायरा`,
      number: `नम्बर`,
      maxPhoneNumbers: `(अधिकतम {{max}})`,
    },

    numberComparisonTable: {
      columns: {
        name: `फोन नम्बर नाम`,
        number: `फोन नम्बर`,
        inboundCalls: `आगमन कलहरू`,
        avgDuration: `औसत अवधि`,
      },
    },

    numberComparisonChart: {
      inboundCalls: `आगमन कलहरू`,
      avgDuration: `औसत अवधि`,
    },

    extensionComparison: {
      retired: `सेवानिवृत्त`,
    },

    extensionComparisonDashboard: {
      invalidDateRange: `अमान्य मिति दायरा`,
      dateRangeTooLarge: `मिति दायरा धेरै ठूलो छ। कृपया ३६५ दिन वा कम को दायरा चयन गर्नुहोस्।`,
      dateRangeAdjustPrompt: `कृपया आफ्नो मिति दायरा समायोजन गर्नुहोस् र पुन: प्रयास गर्नुहोस्।`,
      chartTitle: `एक्सटेन्सनद्वारा कल मात्रा`,
      showingCount: `{{total}} मध्ये {{displayed}} देखाइँदैछ`,
      notAvailable: `उपलब्ध छैन`,
      counters: {
        totalCalls: {
          title: `कुल कलहरू`,
          subtitle: `सबै एक्सटेन्सनहरूमा कुल कलहरू`,
        },
        averageCalls: {
          title: `प्रति एक्सटेन्सन औसत`,
          subtitle: `प्रति एक्सटेन्सन औसत कलहरू`,
        },
        averageMinutes: {
          title: `प्रति एक्सटेन्सन औसत मिनेट`,
          subtitle: `प्रति एक्सटेन्सन औसत मिनेट`,
        },
        topExtension: {
          title: `शीर्ष प्रदर्शनकर्ता`,
        },
      },
      dashboard: {
        errorText: `एक्सटेन्सन डाटा लोड गर्दा त्रुटि`,
        noDataText: `कुनै एक्सटेन्सन डाटा उपलब्ध छैन`,
      },
    },

    extensionComparisonFilters: {
      title: `एक्सटेन्सन तुलना`,
      subtitle: `एक्सटेन्सनहरूमा कल मात्रा तुलना गर्नुहोस्`,
      directionLabel: `दिशा`,
      extensionsLabel: `एक्सटेन्सनहरू`,
      direction: {
        all: `आगमन र बहिर्गमन`,
        inbound: `आगमन`,
        outbound: `बहिर्गमन`,
      },
    },

    extensionComparisonChart: {
      extensionLabel: `एक्सटेन्सन {{ext}}`,
      totalCalls: `कुल कलहरू`,
      totalMinutes: `कुल मिनेट`,
      avgDuration: `औसत अवधि`,
      showMore: `थप देखाउनुहोस् ({{remaining}} बाँकी)`,
      totalCallsTitle: `कुल कलहरू`,
      totalMinutesTitle: `कुल मिनेट`,
    },

    extensionComparisonTable: {
      columns: {
        extension: `एक्सटेन्सन`,
        calls: `कलहरू`,
        percentCalls: `% जम्मा`,
        minutes: `मिनेट`,
        percentMinutes: `% जम्मा`,
      },
    },

    extensionMultiDropdown: {
      allExtensions: `सबै एक्सटेन्सनहरू`,
    },

    extensionPills: {
      extensionsSelected: `{{count}} एक्सटेन्सनहरू चयन गरिएको`,
    },

    dashboards: {
      csvExport: {
        buttonLabel: `सीएसभी निर्यात`,
        exported: `निर्यात भयो`,
        success: `सीएसभी निर्यात भयो`,
        failed: `सीएसभी निर्यात असफल भयो`,
        headers: {
          inboundAnswerRate: {
            startDateTime: `सुरु मिति/समय`,
            endDateTime: `अन्त्य मिति/समय`,
            answeredCalls: `उत्तर दिइएका कलहरू`,
            missedCalls: `छुटेका कलहरू`,
            totalCalls: `कुल कलहरू`,
            answerRatePercent: `उत्तर दर %`,
          },
          numberComparison: {
            phoneNumber: `फोन नम्बर`,
            displayNumber: `प्रदर्शन नम्बर`,
            name: `नाम`,
            inboundCalls: `आगमन कलहरू`,
            totalDurationSeconds: `कुल अवधि (सेकेन्ड)`,
            averageDurationSeconds: `औसत अवधि (सेकेन्ड)`,
          },
          extensionComparison: {
            extension: `एक्सटेन्सन`,
            totalCalls: `कुल कलहरू`,
            totalMinutes: `कुल मिनेट`,
            totalDurationSeconds: `कुल अवधि (सेकेन्ड)`,
            averageDurationSeconds: `औसत अवधि (सेकेन्ड)`,
          },
        },
      },
      unknown: `अज्ञात`,
      notAvailable: `उपलब्ध छैन`,
      noDataAvailable: `कुनै डाटा उपलब्ध छैन`,
      gettingPbx: `पीबीएक्स प्राप्त गर्दै...`,
      noStatisticsAvailable: `कुनै तथ्याङ्क उपलब्ध छैन`,
      noGridData: `कुनै ग्रिड डाटा छैन`,
      errorLoadingStatistics: `तथ्याङ्क लोड गर्दा त्रुटि`,
      errorLoadingCallData: `कल डाटा लोड गर्दा त्रुटि`,
      noCallDataAvailable: `कुनै कल डाटा उपलब्ध छैन`,
      errorLoadingVoicemailData: `भ्वाइसमेल डाटा लोड गर्दा त्रुटि`,
      noVoicemailDataAvailable: `कुनै भ्वाइसमेल डाटा उपलब्ध छैन`,
    },

    aria: {
      backspace: `ब्याकस्पेस`,
      toggleColorMode: `रंग मोड टगल गर्नुहोस्`,
    },

    callAnalytics: {
      empty: {
        noTranscriptRecord: `उफ् — यो कलको लागि ट्रान्सक्रिप्ट रेकर्ड देखिँदैन.`,
        noCallSelected: `कुनै कल चयन गरिएको छैन`,
      },
      stats: {
        agentTalkTime: `एजेन्ट बोल्ने समय`,
        talking: `बोलिरहेको: {{duration}} ({{percent}}%)`,
        listening: `सुनिरहेको: {{duration}} ({{percent}}%)`,
        agentTalkSpeed: `एजेन्ट बोल्ने गति`,
        wordsPerMinute: `प्रति मिनेट {{count}} शब्द (औसत)`,
        holdTimeAndPauses: `होल्ड समय र पजहरू`,
        holdPercentOfCall: `{{duration}} (कलको {{percent}}%)`,
        interruptionsTotal: `अवरोधहरू: जम्मा {{count}}`,
        interruptionsAgent: `एजेन्ट: {{count}} ({{percent}}%)`,
        interruptionsCustomer: `ग्राहक: {{count}} ({{percent}}%)`,
      },
      transcript: {
        office: `कार्यालय`,
        patient: `बिरामी`,
        silence: `मौनता {{duration}}`,
        playFrom: `{{time}} बाट प्ले गर्नुहोस्, {{speaker}}`,
        pauseFrom: `{{time}} बाट रोक्नुहोस्, {{speaker}}`,
      },
    },

    filterModal: {
      header: `फिल्टरहरू`,
      apply: `फिल्टर लागू गर्नुहोस्`,
      clear: `साफ गर्नुहोस्`,
      clearSection: `{{title}} साफ गर्नुहोस्`,
      buttonTitle: `फिल्टरहरू`,
      tooltipOneApplied: `{{title}} ({{count}} फिल्टर लागू)`,
      tooltipManyApplied: `{{title}} ({{count}} फिल्टर लागू)`,
    },

    previewModal: {
      rotate: `घुमाउनुहोस्`,
      imagePreview: `छवि पूर्वावलोकन`,
    },

    pdfViewer: {
      loadError: `यो फाइल लोड गर्न सकिएन`,
    },

    mangoPlusAds: {
      stayRelevant: `सान्दर्भिक रहनुहोस्`,
      inTodaysWorld: `आजको संसारमा`,
      bodyHeading: `कसलाई टेक्स्ट मन पर्दैन?`,
      paragraph1: `आजकल मानिसहरू फोन कलभन्दा टेक्स्ट मन पराउँछन्. आफ्ना ग्राहकहरूलाई टेक्स्ट गर्नुहोस् — समय र ऊर्जा बचत गर्नुहोस्!`,
      paragraph2: `टेक्स्टिङ Mango Plus का धेरै फाइदाहरूमध्ये एक हो. किन्नु अघि हाम्रो बिक्री टोलीसँग एक महिनाको ट्रायलबारे कुरा गर्नुहोस्.`,
      learnMore: `थप जान्नुहोस्`,
    },

    outboundPhoneSearch: {
      placeholder: `नम्बर चयन गर्नुहोस्`,
    },

    faxFilters: {
      directionTooltip: `दिशा फिल्टर`,
      allFaxes: `सबै फ्याक्स`,
    },

    messagingThread: {
      dropFileToSend: `पठाउन फाइल छोड्नुहोस्`,
    },

    resetPassword: {
      togglePasswordVisibility: `पासवर्ड देखाउने/लुकाउने`,
    },

    resourceErrorBoundary: {
      defaultMessage: `अप्रत्याशित त्रुटि भयो.`,
      notFoundFallback: `उफ्, यो रेकर्ड मेटिएको छ वा अवस्थित छैन. मद्दत चाहिन्छ भने समर्थनलाई सम्पर्क गर्नुहोस्.`,
      takeMeBack: `फिर्ता जानुहोस्`,
    },

    moveFaxModal: {
      toast: {
        errorMoving: `फ्याक्स सार्दा त्रुटि भयो.`,
        notMarkedUnread: `फ्याक्स नपढिएको भनी चिन्ह लगाइएन.`,
        moveFailed: `चयन गरिएको भर्चुअल फ्याक्समा फ्याक्स सार्न सकिएन.`,
        errorTitle: `फ्याक्स सार्दा त्रुटि`,
      },
      noAccessWarning: `चयन गरिएको भर्चुअल फ्याक्समा पहुँच छैन भने सारिएपछि तपाईंले यो फ्याक्स हेर्न सक्नुहुने छैन.`,
    },

    filePrinter: {
      printFailed: `फाइल प्रिन्ट गर्न असफल.`,
    },

    router: {
      loadingContent: `सामग्री लोड हुँदै...`,
    },

    resourceFailedToLoad: {
      permission: `यो भ्वाइसमेल बक्समा पहुँच गर्ने अनुमति छैन`,
      deleted: `भ्वाइसमेल मेटाइयो`,
      unavailable: `भ्वाइसमेल उपलब्ध छैन`,
      contactAdmin: `पहुँच पाउन आफ्नो प्रणाली प्रशासकलाई सम्पर्क गर्नुहोस्`,
    },

    tagInput: {
      commaSeparated: `धेरै मानहरू अल्पविरामले छुट्याउनु पर्छ`,
      removeTag: `{{value}} हटाउनुहोस्`,
      valueNotAdded: `यो मान थप्न सकिएन`,
      valuesNotAdded: `यी मानहरू थप्न सकिएन`,
      invalidValue: `यो मान मान्य {{valueType}} होइन`,
      invalidValues: `यी मानहरू मान्य {{valueType}} होइनन्`,
      limitReached: `अधिकतम {{maxTags}} पुग्यो। अर्को थप्न एउटा हटाउनुहोस्।`,
      errorAndLimit: `{{error}}। {{limit}}`,
    },

    unsavedChangesDialog: {
      title: `सुरक्षित नगरिएका परिवर्तनहरू`,
      body: `तपाईंसँग सुरक्षित नगरिएका परिवर्तनहरू छन्. यो पृष्ठ छाड्न निश्चित हुनुहुन्छ? परिवर्तनहरू हराउनेछन्.`,
      stay: `पृष्ठमा बस्नुहोस्`,
      discard: `परिवर्तनहरू रद्द गर्नुहोस्`,
    },

    blockedNumber: {
      blockNumbers: `नम्बरहरू ब्लक गर्नुहोस्`,
    },

    notificationsBanner: {
      grantedPrefix: `राम्रो, सूचना प्राथमिकताहरू यहाँ समायोजन गर्न सकिन्छ`,
      settings: `सेटिङहरू`,
      prompt: `Mango सूचनाहरूसँग सबैभन्दा राम्रो काम गर्छ.`,
      enable: `सूचनाहरू सक्षम गर्नुहोस्!`,
    },

    switchboardEdit: {
      invalidDialPlan: `अमान्य एक्सटेन्सन डायल योजना`,
      invalidPbxId: `अमान्य पीबीएक्स ID`,
      loading: `स्विचबोर्ड लोड हुँदै...`,
    },

    webPhoneExtras: {
      activeCall: `सक्रिय कल`,
      failedSearch: `खोज असफल`,
      otherLabel: `अन्य`,
      awayWithLabel: `बाहिर - {{label}}`,
    },

    callDetailsExtras: {
      callInProgress: `कल प्रगतिमा`,
      mayTakeMinutes: `यसमा केही मिनेट लाग्न सक्छ`,
    },

    contactCombinedCell: {
      fromPrefix: `बाट:`,
      toPrefix: `लाई:`,
    },

    responsivePage: {
      showList: `सूची देखाउनुहोस्`,
      hideList: `सूची लुकाउनुहोस्`,
    },

    loadingSpinner: {
      label: `लोड हुँदैछ`,
    },

    messaging:
      messagingNe as unknown as (typeof en)['translation']['messaging'],
    phoneNumbers:
      phoneNumbersNe as unknown as (typeof en)['translation']['phoneNumbers'],
    pbxLocations:
      pbxLocationsNe as unknown as (typeof en)['translation']['pbxLocations'],
    musicOnHold:
      musicOnHoldNe as unknown as (typeof en)['translation']['musicOnHold'],
    hotels: hotelsNe as unknown as (typeof en)['translation']['hotels'],
    soundClips:
      soundClipsNe as unknown as (typeof en)['translation']['soundClips'],
    ...systemSettingsNe,
    pbxSettings:
      pbxSettingsNe as unknown as (typeof en)['translation']['pbxSettings'],
    devices: devicesNe as unknown as (typeof en)['translation']['devices'],
    extensions:
      extensionsNe as unknown as (typeof en)['translation']['extensions'],
    userGroups:
      userGroupsNe as unknown as (typeof en)['translation']['userGroups'],
    webhooks: webhooksNe as unknown as (typeof en)['translation']['webhooks'],
  },
  support_phone_label: `सहायता हटलाइन: {{phoneNumber, phone}}`,
  user_profile_phone: `तपाईंको दर्ता गरिएको फोन नम्बर: {{userPhone, phone}}`,
} satisfies typeof en
